import zhHans from 'vuetify/es5/locale/zh-Hans';
export default {
    ...zhHans,
    setting: {
        language: "Kinezçe e thjeshtuar",
        dialogDetermine: "Konfirmo",
        dreivatives: "Kontrata të dorëzimit",
        markets: "Tregjet",
        assets: "Asetet",
        liquidity: "Minierat e likuiditetit",
        helpCentre: "Qendra e ndihmës",
        announcementCenter: "Qendra e njoftimeve",
        about: "Rreth",
        bulletinCentre: "Qendra e njoftimeve",
        serviceAgreement: "Marrëveshja e shërbimit",
        support: "Mbështetje",
        onlineSupportCustomerService: "Shërbimi i klientit online",
        suggestionsAndFeedback: "Sugjerime dhe komente",
        service: "Shërbim",
        download: "Shkarko",
        coinApplication: "Aplikim për listim monedhe",
        privacyStatement: "Deklarata e privatësisë",
        trade: "Tregtia me kontrata",
        standardConteact: "Kontrata e përhershme",
        signOut: "Dil",
        assetWallets: "Portofol i aseteve",
        financeRecords: "Regjistrat financiarë",
        identification: "Verifikimi i identitetit",
        personalCenter: "Qendra personale",
        chooseLanguage: "Zgjidh gjuhën",
        tips: "Këshillë",
        dark: "Modaliteti i natës",
        light: "Modaliteti i ditës",
        languageTitle: "Gjuha",
        convertCurrency: "Konvertimi i valutës",
        cancel: "Anulo",
        aboutUs: "Rreth nesh",
        standard: "Kontrata e përhershme standarde",
        share: "Ndaj",
        introduce: "Prezantimi i platformës",
        set: "Cilësimet",
        changePassword: "Ndrysho fjalëkalimin",
        denomination: "Monedha e llogaritjes",
        color: "Konfigurimi i ngjyrave",
        code: "Numri i versionit",
        color1: "E kuqe ngjitje, e gjelbër rënie",
        color2: "E gjelbër ngjitje, e kuqe rënie",
        setLangue: "Vendos gjuhën",
        vip: "Përfitimet VIP",
        vip2: "Niveli aktual VIP",
        safeMenu: "Qendra e sigurisë",
        conventional: "Konvencionale",
        other: "Tjetër",
        quickTips: "Mund të shtoni deri në 3 butona funksionesh të shpejta",
        quickTransaction: "Transaksion i shpejtë",
        safeConvenient: "I sigurt dhe i përshtatshëm",
        timeSharing: "Grafiku në kohë reale",
        currentLevel: "Niveli aktual",
        levelBenefits: "Përfitimet e nivelit %{level}",
        teamLevel: "Niveli i ekipit",
        levelLower: "Niveli %{level} nën-nivel",
        rules: "Shpjegimi i rregullave",
        bindWithdrawalAddress: "Lidheni adresën e tërheqjes",
        tipsBindWithdrawalAddress: "Nuk keni lidhur ende adresën e tërheqjes, ju lutemi lidheni më parë",
        walletAddressFormatIncorrect: "Formati i adresës së portofolit është i pasaktë",
        tradeRules1: "Parashikoni ngritjen ose rënien në një periudhë të ardhshme. Çmimi në momentin e vendosjes së porosisë është çmimi fillestar, ndërsa çmimi në sekondën e fundit të ciklit të parashikimit është çmimi i zgjidhjes. Nëse çmimi i zgjidhjes është më i madh se çmimi fillestar, atëherë është ngritje; nëse është më i vogël, atëherë është rënie.",
        tradeRules2: "1. Çfarë është kontrata",
        tradeRules3: "Ky platformë ofron kontrata të përhershme të bazuara në USDT. Përdoruesit mund të gjenerojnë fitim nga lëvizjet e çmimit të aseteve digjitale duke zgjedhur të blejnë (shko gjatë) ose të shesin (shko shkurt) kontrata. Kontratat e përhershme nuk kanë datë dorëzimi, kështu që përdoruesit mund t’i mbajnë ato pa afat.",
        tradeRules4: "2. Çfarë është marzhi (garancia)",
        tradeRules5: "Në tregun e kontratave virtuale, përdoruesi duhet të paguajë vetëm një shumë të vogël të fondeve, sipas një përqindjeje të caktuar të çmimit të kontratës, si garanci financiare për përmbushjen e kontratës, dhe kështu mund të marrë pjesë në blerjen ose shitjen e kontratave. Kjo shumë quhet marzhi i kontratës virtuale.\nKontratat e kësaj platforme përdorin modelin e marzhit të izoluar sipas llogarive të ndara. Çdo monedhë ka një llogari të veçantë kontrate; asetet dhe pozicionet e monedhave të ndryshme janë të pavarura, dhe transfertat ose tregtimet midis tyre nuk ndikojnë njëra-tjetrën. Pas hapjes së një pozicioni, të gjitha rreziqet dhe fitimet e atij llogari kontrate llogariten së bashku.",
        tradeRules6: "3. Si llogaritet marzhi",
        tradeRules7: "Marzhi i pozicionit = Vlera e kontratës * Numri i kontratave të mbajtura / Shumëzuesi i levës\nMarzhi i ngrirë = Shuma totale e marzhit për të gjitha urdhrat e hapura me sukses në pritje\nMarzhi i disponueshëm = Bilanci i llogarisë - Marzhi i pozicionit - Marzhi i ngrirë",
        tradeRules8: "4. Si llogaritet shkalla e marzhit",
        tradeRules9: "Shkalla e marzhit është një tregues për matjen e rrezikut të aseteve të përdoruesit.\nShkalla e marzhit = (Fitimi/humbja e parealizuar + Marzhi i pozicionit + Marzhi i disponueshëm + Marzhi i ngrirë - Komisioni i mbylljes së pozicionit) / Marzhi i pozicionit\nSa më e vogël të jetë shkalla e marzhit, aq më i lartë është rreziku i llogarisë. Kur shkalla e marzhit është më e vogël ose e barabartë me 0%, aktivizohet mbyllja e detyruar e pozicionit.",
        tradeRules10: "5. Çfarë është çmimi i parashikuar i mbylljes së detyruar",
        tradeRules11: "Çmimi i parashikuar i mbylljes së detyruar është çmimi teorik i llogaritur nga sistemi për të aktivizuar mbylljen e detyruar, vetëm për referencë, dhe mund të ketë një devijim të vogël nga vlera reale.",
        tradeRules12: "6. Çfarë janë të drejtat totale të llogarisë dhe fitimi/humbja e parealizuar",
        tradeRules13: "Të drejtat totale të llogarisë = Bilanci i llogarisë + Fitimi/humbja e parealizuar\nFitimi/humbja e parealizuar është ndryshimi i vlerës së pozicioneve aktuale të kontratave që përdoruesi mban për një monedhë të caktuar. Kjo ndryshon me lëvizjen e çmimit më të fundit të tregut.\nFitimi/humbja e parealizuar për pozicionet e gjata = (1/Çmimi mesatar i pozicionit - 1/Çmimi më i fundit i tregut) * Numri i kontratave të gjata * Vlera e kontratës * Çmimi më i fundit i tregut\nFitimi/humbja e parealizuar për pozicionet e shkurtra = (1/Çmimi më i fundit i tregut - 1/Çmimi mesatar i pozicionit) * Numri i kontratave të shkurtra * Vlera e kontratës * Çmimi më i fundit i tregut",
        text1: "Siguria e llogarisë",
        text2: "Modaliteti ditë/natë",
        text3: "Pastro memorien",
        text4: "Jeni i sigurt që doni të dilni?",
        text5: "Jeni i sigurt që doni të pastroni memorien?",
        text6: "Shumëgjuhëshe",
        text7: "Për të mbrojtur sigurinë tuaj, rekomandohet të aktivizoni të paktën një metodë të verifikimit me dy faktorë"
    },
    login: {
        login: "Hyrje",
        register: "Regjistrohu",
        title1: "Tregtoni kudo dhe kurdo, shikoni tregun në kohë reale",
        title2: "Tregtoni kudo dhe kurdo, shikoni tregun në kohë reale",
        title3: "Platforma më e besueshme për tregtimin e kriptomonedhave",
        formTitle1: "Hyrje në llogari",
        formTitle2: "Mirë se u kthyet! Përdorni email-in ose numrin e telefonit tuaj për t’u futur",
        btn1: "Telefon",
        btn2: "Email",
        btn3: "Hyr",
        btn4: "Regjistrohu",
        btn5: "Keni harruar fjalëkalimin?",
        field1: "Numri i telefonit",
        field2: "Fjalëkalimi",
        field3: "Email",
        placeholder1: "Shteti",
        placeholder2: "Ju lutemi shkruani numrin e telefonit",
        placeholder3: "Ju lutemi shkruani fjalëkalimin",
        placeholder4: "Ju lutemi shkruani email-in",
        content12: "Ju lutemi shkruani numrin e telefonit",
        content13: "Ju lutemi shkruani fjalëkalimin",
        content14: "Ju lutemi shkruani email-in",
        content16: "Shërbime financiare për asete digjitale",
        loginSuccess: "Hyrja ishte e suksesshme",
        chooseArea: "Ju lutemi zgjidhni kodin e vendit",
        placeholder5: "Ju lutemi zgjidhni kodin e vendit",
        placeholder6: "Më kujto fjalëkalimin tim",
        placeholder7: "Shkarko aplikacionin",
        placeholder8: "Kontaktoni shërbimin e klientit",
        placeholder9: "Zgjidhni shtetin ose rajonin",
        placeholder10: "Kodi i vendit",
        placeholder11: "Hyrje me portofol",
        placeholder12: "Operacioni dështoi, ju lutemi kaloni në",
        placeholder13: "Portofol"
    },
    aboutUs: {
        aboutCoinbeadCenterTitle: "Rreth",
        aboutCoinbeadCenterDetails: "Një nga platformat më të avancuara në botë për tregtimin e aseteve blockchain, duke operuar gjithashtu gjithë ekosistemin.",
        footDetails1: "Vëllimi ditor i tregtimit",
        footDetails2: "Transaksione për sekondë",
        footDetails3: "Qendra e ndihmës",
        coinbeadCenterTitle: "",
        coinbeadCenterDetails: "Është një platformë ndërkombëtare e njohur për asetet digjitale, që u ofron përdoruesve globalë tregtimin e Bitcoin (BTC), Litecoin (LTC), Ethereum (ETH) dhe derivateve të tjera digjitale.",
        coinbeadCenterDetailsm: "Përdor teknologji të avancuara si GSLB, serverë rrjeti, tregti rrjeti, rrjet me rezerva të shumta, motor tregtimi me kujtesë të shpejtë, portofol të ftohtë, portofol të nxehtë të menaxhuar në mënyrë inteligjente offline, etj. Përmes Web-it, aplikacioneve mobile dhe PC, ne ofrojmë shërbime tregtare të sigurta, të qëndrueshme dhe të besueshme për asetet digjitale. Në të njëjtën kohë, bazuar në sugjerimet dhe nevojat e përdoruesve, ne përmirësojmë dhe përditësojmë produktet dhe shërbimet, duke ofruar gjithmonë një shërbim më të mirë dhe një përvojë përdoruesi inovative pa fund.",
        infrastructureCenterTitle: "Infrastruktura",
        infrastructureCenterDetails: "Misioni ynë është të ofrojmë shërbime infrastrukturore për gjithë ekosistemin blockchain.",
        freeCenterTitle: "Liria",
        freeCenterDetails: "Vizioni ynë është të bëjmë që paratë të qarkullojnë lirshëm në të gjithë botën. Ne besojmë se përhapja e kësaj lirie do ta bëjë botën një vend më të mirë.",
        futureCenterTitle: "E ardhmja e teknologjisë",
        futureCenterDetails: "Hapni të ardhmen e teknologjisë",
    },
    applicationForListing: {
        title: "Aplikim për listim monedhe",
        projectName: "Emri i projektit",
        tokenName: "Emri i tokenit",
        projectDescription: "Përshkrimi i projektit",
        contractAddress: "Adresa e kontratës",
        officialWebsite: "Faqja zyrtare",
        ContactAndEmail: "Email i kontaktit",
        ContactAndName: "Emri i kontaktit",
        file: "Ngarko bashkëngjitjen",
        pleaseEnter: "Ju lutemi shkruani",
        enterFile: "Ju lutemi ngarkoni skedarin",
        upload1: "Aktualisht kufizohet zgjedhja në 1 skedar,",
        upload2: "Këtë herë u zgjodhën",
        upload3: "skedarë,",
        upload4: "Në total janë zgjedhur",
        upload5: "skedarë",
    },
    public: {
        submit: "Dërgo",
        copySuccessfully: "Kopjimi u krye me sukses",
        copyFailed: "Kopjimi dështoi",
        noDate: "Nuk ka të dhëna",
        submitSuccessfully: "Dërgimi u krye me sukses",
        goBack: "Kthehu te faqja e mëparshme",
        cancel: "Anulo",
        home: "Faqja kryesore",
        loading: "Duke u ngarkuar...",
        confirm: "Konfirmo",
        loadingFailed: "Gabim rrjeti",
        nomore: "Nuk ka më",
        tryAgain: "Ju lutemi rifreskoni faqen / dilni nga aplikacioni dhe provoni sërish!",
        hot: "Zona e njohur",
    },
    inviteFriends: {
        inviteFriends: "Ndaj me miqtë",
        freedomOfWealth: "Le të jetë pasuria e lirë së bashku",
        myInvitationCode: "Kodi im i ftesës",
        clickCopy: "Kliko për të kopjuar",
        myInvitationLink: "Lidhja ime e ftesës",
        clicktoSaveTheQRCode: "Kliko për të ruajtur kodin QR",
        saveQRCode: "Kodi QR i ftesës",
        numberOfSubordinates: "Numri i nën-shfrytëzuesve",
        rebateIncome: "Të ardhurat nga komisioni",
        people: "Persona",
        myPromotionRevenue: "Të ardhurat e mia nga promovimi",
        numberOfDirectSubordinates: "Numri i nën-shfrytëzuesve direkt",
        totalNumberOfSubordinates: "Numri total i nën-shfrytëzuesve",
        directSubordinateReturnsCommission: "Komisioni nga nën-shfrytëzuesit direkt",
        theTotalCommission: "Komisioni total",
        checkHistory: "Shiko historikun e komisioneve",
        history: "Historiku i komisioneve",
        theLowerAccount: "Llogaria e nën-shfrytëzuesit",
        type: "Lloji:",
        serviceCharge: "Tarifa e shërbimit:",
        percentageofCommissionReturned: "Përqindja e komisionit të kthyer:",
        commissionrebateAmount: "Shuma e komisionit të kthyer:",
        time: "Koha:",
        typeName1: "Komision i rimbursuar nga depozita",
        typeName2: "Komision i shpërndarjes trefishe nga tarifa e porosive MT",
        typeName3: "Fitim i shpërndarjes trefishe nga MT",
        typeName4: "Shpërblim rekomandimi",
        typeName30: "Komision i rimbursuar nga depozita",
        typeName31: "Komision nga fitimi i tregtisë periodike",
        typeName32: "Komision nga fitimi i minierave të likuiditetit",
        typeName45: "Komision nga tarifat e tregtisë",
        typeName46: "Komision nga tarifat vetjake",
        typeName50: "Komision nga tarifat e kontratave të dorëzimit",
        typeName51: "Komision nga tarifat e kontratave të përhershme",
        typeName52: "Komision shtesë nga tarifat e kontratave të dorëzimit",
        typeName53: "Komision shtesë nga tarifat e kontratave të përhershme",
        typeName54: "Rikthim shtesë nga tarifat e kontratave të përhershme",
        shareRules1: "Udhëzimet e ftesës",
        shareRules2: "Hyni në qendrën e ftesave, kopjoni lidhjen ose kodin e ftesës dhe ndajeni me miqtë tuaj. Pasi miqtë të regjistrohen me kodin tuaj të ftesës, ata bëhen nën-shfrytëzuesit tuaj.",
        shareRules3: "Fitoni komision",
        shareRules4: "Kur nën-shfrytëzuesit bëjnë tregti, ju mund të merrni komisionin përkatës, deri në tre nivele nën-shfrytëzuesish. Për shembull, ju ftoni mikun A, A fton B, dhe B fton C; sa herë që A, B ose C tregtojnë në platformë (p.sh. kontrata), ju fitoni komisionin përkatës.",
        shareRules5: "Niveli i ekipit",
        shareRules6: "Sa më shumë nën-shfrytëzues të nivelit të parë të promovoni, aq më i lartë bëhet niveli i ekipit, dhe aq më shumë përfitime komisionesh do të keni. Nivelet e ekipit ndahen nga LV1-LV6. Rregullat e përditësimit shihen në tabelën më poshtë, ku 'N' është numri i nën-shfrytëzuesve të nivelit të parë që kanë depozituar dhe përfunduar verifikimin e identitetit.",
        shareRules7: "Kur nën-shfrytëzuesit vendosin baste në kontratat e dorëzimit, ju fitoni një përqindje të caktuar të shumës së basteve të tyre si komision.",
        upgradeConditions: "Kërkesat",
        recommendedNumberOfPeople: "Numri i personave të rekomanduar"
    },
    suggestionsAndFeedback: {
        suggestionsAndFeedback: "Sugjerime dhe Komente",
        text: "Nëse hasni ndonjë bug gjatë përdorimit ose keni sugjerime për produktin, ju mirëpresim të na dërgoni feedback",
        email: "Adresa e email-it",
        enterEmail: "Ju lutemi shkruani adresën e email-it",
        enterCorrectEmail: "Ju lutemi shkruani një adresë email-i të saktë",
        title: "Titulli",
        enterTitle: "Ju lutemi shkruani titullin e problemit",
        describeTheProblem: "Përshkruani problemin",
        enterDescribeTheProblem: "Ju lutemi shkruani përshkrimin e problemit tuaj",
        submit: "Dërgo",
    },
    help: {
        enterSearch: "Kërko",
        title: "Qendra e Ndihmës",
        search: "Ju lutemi shkruani pyetjen tuaj",
        text1: "Kuptojmë nevojat tuaja dhe vazhdimisht ju ofrojmë shërbime më të përshtatshme"
    },
    announcement: {
        enterSearch: "Kërko",
        title: "Qendra e Njoftimeve",
        search: "Ju lutemi shkruani pyetjen tuaj"
    },
    privacy: {
        title: "Deklarata e Privatësisë",
        content1: "1. Çfarë informacioni personal mblidhet nga përdoruesit?",
        content2: "Mbledhja e informacionit personal bëhet për të ofruar produkte dhe shërbime dhe për t’i përmirësuar ato vazhdimisht.",
        content3: "Më poshtë janë llojet e informacionit personal që ne mbledhim:",
        content4: "Informacioni që na ofroni: Ne marrim dhe ruajmë çdo informacion që na ofroni lidhur me këtë platformë. Ju mund të zgjidhni të mos ofroni disa informacione, por kjo mund të ndikojë që të mos përdorni disa shërbime të platformës. Shembuj të informacionit që na ofroni përfshijnë:",
        content5: "Emri",
        content6: "Adresa",
        content7: "Shtetësia",
        content8: "Fotografi të dokumenteve identifikuese",
        content9: "Numri i telefonit / adresa e email-it",
        content10: "Informacione të tjera që ndihmojnë në identifikimin tuaj",
        content11: "Informacion i mbledhur automatikisht: Ne mbledhim dhe ruajmë automatikisht disa lloje informacioni mbi përdorimin e shërbimeve të platformës. Ashtu si shumë faqe të tjera, ne përdorim Cookies dhe identifikues unikë. Kur shfletuesi juaj ose pajisja juaj akseson platformën, ne marrim disa lloje informacioni. Shembuj të informacionit që mbledhim dhe analizojmë përfshijnë:",
        content12: "Adresa e Protokollit të Internetit (IP) e kompjuterit tuaj personal që lidhet me internetin;",
        content13: "Të dhënat e hyrjes të pajisjes ose kompjuterit personal, adresa e email-it, fjalëkalimi dhe vendndodhja;",
        content14: "Versioni dhe cilësimet e zonës kohore;",
        content15: "Historia e transaksioneve.",
        content16: "Informacion nga burime të tjera: Ne mund të mbledhim informacion rreth jush nga burime të tjera (p.sh. historiku i kredive nga agjencitë e vlerësimit të kredive). Ky informacion përdoret për të parandaluar dhe zbuluar mashtrimet.",
        content17: "2. A mund të përdorin fëmijët shërbimet?",
        content18: "Platforma nuk lejon asnjë individ nën 18 vjeç të përdorë shërbimet.",
        content19: "3. Për çfarë shërbejnë Cookie dhe identifikuesit e tjerë?",
        content20: "Ne përdorim Cookies dhe mjete të ngjashme për të optimizuar përvojën e përdoruesit, për të ofruar shërbimet tona dhe për të kuptuar sesi përdoruesit i përdorin shërbimet tona, në mënyrë që të bëjmë përmirësime të synuara. Ne përdorim Cookies për të siguruar që sistemi ynë mund të njohë shfletuesin ose pajisjen tuaj dhe t’ju ofrojë shërbime.",
        content21: "Ne përdorim Cookies funksionale dhe mjete të ngjashme (të quajtura së bashku “Cookies”) për të ofruar shërbime, si për shembull:",
        content22: "Të njohim identitetin tuaj kur hyni dhe përdorni shërbimet tona.",
        content23: "Të ofrojmë funksione dhe shërbime të personalizuara.",
        content24: "Të parandalojmë aktivitete mashtruese.",
        content25: "Të rrisim sigurinë.",
        content26: "Të gjurmojmë preferencat tuaja (p.sh. monedhën dhe gjuhën).",
        content27: "Ne gjithashtu përdorim Cookies për të kuptuar sesi përdoruesit i përdorin shërbimet tona, në mënyrë që të bëjmë përmirësime të synuara.",
        content28: "4. A do të ndahet informacioni im personal?",
        content29: "Informacioni i përdoruesit është një pjesë e rëndësishme e biznesit tonë dhe ne nuk shesim informacion personal të përdoruesve tek palët e treta. Platforma ndan informacionin personal vetëm në rastet e mëposhtme me filialet ose partnerët tanë, të cilët duhet të respektojnë këtë Deklaratë Privatësie ose të paktën praktika që ofrojnë të njëjtin nivel mbrojtjeje.",
        content30: "Furnizuesit e shërbimeve të palëve të treta: Ne punësojmë kompani dhe individë të tjerë për të kryer funksione në emrin tonë. Shembuj të këtyre funksioneve përfshijnë: analizimin e të dhënave, ofrimin e ndihmës në marketing, përpunimin e pagesave, transmetimin e përmbajtjes dhe vlerësimin dhe menaxhimin e rrezikut të kredisë. Këta furnizues mund të kenë akses vetëm në informacionin personal të nevojshëm për të kryer funksionet e tyre, por nuk mund ta përdorin atë për qëllime të tjera. Përveç kësaj, ata duhet të përpunojnë informacionin personal në përputhje me këtë Deklaratë Privatësie dhe ligjet përkatëse për mbrojtjen e të dhënave.",
        content31: "Transferimi i biznesit: Ndërsa biznesi ynë vazhdon të zhvillohet, ne mund të shesim ose blejmë biznese ose shërbime të tjera. Në transaksione të tilla, informacioni i përdoruesve zakonisht konsiderohet një aktiv biznesi që transferohet, por gjithmonë mbetet i mbrojtur nga çdo deklaratë privatësie ekzistuese (përveç nëse përdoruesi pajtohet ndryshe). Gjithashtu, nëse kompania jonë ose shumica e aseteve të saj blihen, informacioni i përdoruesve do të transferohet. Për mbrojtjen e kompanisë dhe të tjerëve: Kur besojmë se publikimi i llogarive ose informacioneve personale është i nevojshëm për të respektuar ligjin ose detyrimet tona rregullatore, për të zbatuar kushtet e përdorimit ose marrëveshjet e tjera, apo për të mbrojtur të drejtat, pronën ose sigurinë e përdoruesve ose të tjerëve, ne mund t’i ndajmë ato. Kjo përfshin shkëmbimin e informacionit me kompani dhe organizata të tjera për të parandaluar mashtrimet dhe për të ulur rrezikun e kredisë.",
        content32: "5. Transferimi ndërkombëtar i të dhënave personale",
        content33: "Ne mund t’i transferojmë të dhënat tuaja në rajone jashtë Zonës Ekonomike Evropiane (“EEA”). Ne do të marrim masa të përshtatshme sigurie për të siguruar që ky transferim është në përputhje me rregullat e aplikueshme të mbrojtjes së të dhënave, përveç rasteve kur Komisioni Evropian ka konfirmuar që vendi/rajoni pritës ofron një nivel të mjaftueshëm mbrojtjeje.",
        content34: "6. A është i sigurt informacioni im personal?",
        content35: "Kur projektojmë sistemet tona, gjithmonë marrim në konsideratë sigurinë dhe privatësinë tuaj. Ne përdorim protokolle dhe software enkriptimi për të mbrojtur informacionin personal gjatë transmetimit.",
        content36: "Në mbledhjen, ruajtjen dhe publikimin e informacionit personal, ne gjithmonë zbatojmë masa sigurie fizike, elektronike dhe procedurale. Procedurat tona të sigurisë nënkuptojnë se para se t’ju japim akses në informacionin personal, mund të na duhet të verifikojmë identitetin tuaj.",
        content37: "Për ju, më e rëndësishmja është të parandaloni hyrjen e paautorizuar në fjalëkalimin e llogarisë tuaj. Ne rekomandojmë të vendosni një fjalëkalim unik për llogarinë tuaj, ndryshe nga ato që përdorni për llogari të tjera online. Për më tepër, sigurohuni të dilni nga llogaria pas përdorimit të kompjuterëve të përbashkët.",
        content38: "7. Si duhet të mbroj informacionin personal?",
        content39: "Nëse keni ndonjë pyetje ose kundërshtim mbi mënyrën se si ne mbledhim dhe përpunojmë informacionin personal, ju lutemi kontaktoni shërbimin e klientit.",
        content40: "Pasi të keni dhënë pëlqimin për përpunimin e informacionit tuaj personal për një qëllim specifik, ju mund ta tërhiqni atë pëlqim në çdo kohë dhe ne do të ndalojmë përpunimin e të dhënave për atë qëllim.",
        content41: "Gjithashtu, në përputhje me ligjet përkatëse, ju keni të drejtën të kërkoni akses, korrigjim dhe fshirje të të dhënave personale, si dhe të kërkoni transferimin e tyre. Ju gjithashtu mund të kundërshtoni përpunimin e të dhënave tuaja personale ose të kërkoni që në disa raste të kufizohet përpunimi i tyre.",
        content42: "8. GDPR i BE-së dhe Ligji për Mbrojtjen e të Dhënave në Mbretërinë e Bashkuar – Baza ligjore",
        content43: "GDPR i BE-së dhe ligjet për mbrojtjen e të dhënave në Mbretërinë e Bashkuar kërkojnë që ne të mbështetemi në një bazë ligjore për përdorimin e informacionit personal. Baza jonë varet nga qëllimi i veçantë i përdorimit të informacionit personal. Këto baza përfshijnë:",
        content44: "Përmbushja e kontratës – Ofrimi i produkteve ose shërbimeve për ju ose komunikimi mbi çështje të lidhura, duke përfshirë përdorimin e informacionit tuaj personal për të pranuar dhe përpunuar porositë si dhe për të përpunuar pagesat.",
        content45: "Interesat tona legjitime të biznesit dhe interesat e përdoruesve – Ne zbulojmë dhe parandalojmë mashtrimet dhe abuzimet, duke mbrojtur sigurinë e përdoruesve tanë, tonën dhe të të tjerëve.",
        content46: "Pëlqimi juaj – Ne kërkojmë pëlqimin tuaj për të përpunuar informacionin personal për qëllime specifike të cilat ua kemi komunikuar. Pasi jepni pëlqimin, ju mund ta tërhiqni atë në çdo kohë dhe ne do të ndalojmë përpunimin e të dhënave për atë qëllim.",
        content47: "Përmbushja e detyrimeve ligjore – Ne përdorim informacionin tuaj personal sipas kërkesave ligjore. Për shembull, ne mbledhim informacion mbi llogarinë bankare për qëllime verifikimi të identitetit.",
        content48: "Pikat e mësipërme dhe baza të tjera ligjore varen nga qëllimi specifik i përdorimit të informacionit personal.",
        content49: "9. Kushtet e përdorimit, njoftimet dhe përditësimet",
        content50: "Përdorimi juaj dhe çdo mosmarrëveshje mbi të drejtat e privatësisë do të jenë subjekt i kësaj deklarate dhe kushteve tona të përdorimit. Nëse keni shqetësime mbi privatësinë në këtë platformë, ju lutemi na kontaktoni duke dhënë një përshkrim të detajuar dhe ne do të bëjmë çmos për ta zgjidhur problemin. Ju gjithashtu keni të drejtën të kontaktoni autoritetin e mbrojtjes së të dhënave në vendin tuaj.",
        content51: "Biznesi ynë ndryshon vazhdimisht dhe deklarata e privatësisë gjithashtu mund të ndryshojë. Ju duhet të vizitoni rregullisht faqen tonë për të parë ndryshimet e fundit. Nëse nuk jeni dakord me versionin e përditësuar, duhet të ndaloni menjëherë përdorimin. Pas publikimit të një versioni të ri të politikës së privatësisë, vazhdimi i përdorimit të platformës do të konsiderohet si pranimi juaj i përmbajtjes së re dhe pajtueshmëria me të. Përveç rasteve të veçanta, deklarata aktuale e privatësisë zbatohet për të gjitha informacionet që kemi për ju dhe llogarinë tuaj.",
    },
    serviceAgreement: {
        title: "Marrëveshja e Shërbimit",
        content1: "Ky website është një platformë e krijuar posaçërisht për përdoruesit për të kryer tregti me asete digjitale dhe për të ofruar shërbime të lidhura (më poshtë quajtur “Shërbimi” ose “Shërbimet”). Për lehtësinë e këtij marrëveshjeje, ky website do të referohet si “ne” ose me të tjera shprehje në vetën e parë. Çdo person fizik apo subjekt tjetër që hyn në këtë website është përdorues i tij dhe do të referohet si “ju” ose me shprehje të tjera në vetën e dytë. Së bashku ne dhe ju do të quhemi “palët”, ndërsa secila veçmas si “palë”.",
        content2: "Këshillë e rëndësishme:",
        content3: "Ne ju kujtojmë posaçërisht:",
        content4: "1 Asetet digjitale nuk emetohen nga ndonjë institucion financiar, kompani apo ky website.",
        content5: "2 Tregu i aseteve digjitale është i ri, i paqëndrueshëm dhe mund të mos zhvillohet;",
        content6: "3 Asetet digjitale përdoren kryesisht nga spekulatorë dhe më pak nga tregjet me pakicë apo ato tregtare. Tregtimi i aseteve digjitale mbart rrezik shumë të lartë; është i vazhdueshëm 24 orë, nuk ka kufi ngritjeje apo rënieje, dhe çmimet mund të ndryshojnë ndjeshëm për shkak të faktorëve si spekulatorët e mëdhenj dhe politikat qeveritare globale;",
        content7: "4 Nëse kompania, sipas gjykimit të saj të vetëm, vlerëson se ju keni shkelur këtë marrëveshje, ose sipas ligjeve të juridiksionit tuaj përdorimi i këtij shërbimi është i paligjshëm, atëherë kompania ka të drejtë të pezullojë ose mbyllë llogarinë tuaj në çdo kohë, ose të ndalojë përdorimin e shërbimeve të ofruara nga ky website ose të tregtimit të aseteve digjitale. Ndalohet përdorimi i shërbimit të kontratave nga persona me origjinë nga: 【Kina kontinentale, Tajvani, Izraeli, Iraku, Bangladeshi, Bolivia, Ekuadori, Kirgistani, Sevastopoli, Mbretëria e Bashkuar (përdoruesit me pakicë)】. Lista e vendeve ose rajoneve të ndaluara mund të ndryshojë në përputhje me politikat e vendeve apo rajoneve dhe tipet e produkteve. Ne mund të mos ju njoftojmë posaçërisht, prandaj ju duhet të kontrolloni shpesh përditësimet e kësaj marrëveshjeje.",
        content8: "Tregtimi i aseteve digjitale ka rrezik shumë të lartë dhe nuk është i përshtatshëm për shumicën e njerëzve. Ju e kuptoni që ky tregtim mund të sjellë humbje të pjesshme ose të plota, prandaj duhet të vendosni shumën e tregtimit sipas aftësisë suaj për të përballuar humbjen. Ju e kuptoni gjithashtu që aseteve digjitale u bashkëngjiten rreziqe dytësore; në rast dyshimi, rekomandohet të konsultoheni me një këshilltar profesionist. Përveç rreziqeve të përmendura, mund të ekzistojnë edhe rreziqe të paparashikuara. Ju duhet të vlerësoni me kujdes situatën tuaj financiare dhe rreziqet përpara se të merrni vendime për tregtimin e aseteve digjitale dhe do të mbani përgjegjësi të plotë për çdo humbje. Ne nuk mbajmë asnjë përgjegjësi.",
        content9: "Ju njoftojmë:",
        content10: "1 Ju e kuptoni që ky website shërben vetëm si një vend ku mund të merrni informacion mbi asetet digjitale, të gjeni palë tregtare, të negocioni dhe të kryeni tregti. Ne nuk marrim pjesë në asnjë tregti tuajën, prandaj ju duhet të vlerësoni vetë dhe me kujdes vlefshmërinë, ligjshmërinë dhe saktësinë e aseteve digjitale apo informacionit, duke mbajtur përgjegjësi për çdo humbje që lind prej tyre.",
        content11: "2 Çdo mendim, lajm, diskutim, analizë, çmim, këshillë apo informacion tjetër në këtë website është vetëm koment tregu dhe nuk përbën këshillë investimi. Ne nuk mbajmë përgjegjësi për ndonjë humbje që lind drejtpërdrejt ose tërthorazi nga mbështetja tek këto informacione, përfshirë por jo të kufizuara tek humbjet e fitimeve.",
        content12: "3 Ky website rezervon të drejtën të ndryshojë ose modifikojë përmbajtjen në çdo kohë sipas vullnetit tonë. Ne kemi marrë masa të arsyeshme për të siguruar saktësinë e informacionit, por nuk garantojmë plotësinë e tij dhe nuk mbajmë përgjegjësi për humbje që lindin nga vonesat ose dështimet në marrjen ose transmetimin e informacionit përmes internetit.",
        content13: "4 Përdorimi i sistemit të tregtimit përmes internetit mbart rreziqe, përfshirë por jo të kufizuara tek dështimet e softuerit, harduerit dhe lidhjes së internetit. Meqenëse nuk mund të kontrollojmë besueshmërinë dhe disponueshmërinë e internetit, ne nuk mbajmë përgjegjësi për shtrembërime, vonesa apo dështime lidhjeje.",
        content14: "5 Ndalohet përdorimi i këtij website për pastrim parash, kontrabandë, ryshfete tregtare apo aktivitete të tjera të paligjshme. Nëse zbulojmë ndonjë aktivitet të tillë, ky website do të marrë masa, përfshirë por jo të kufizuara tek ngrirja e llogarive dhe njoftimi i autoriteteve përkatëse. Ne nuk mbajmë përgjegjësi për këto raste dhe ruajmë të drejtën të ndjekim penalisht përgjegjësit.",
        content15: "6 Ndalohet përdorimi i këtij website për manipulim të tregut, tregti të padrejta apo aktivitete të tjera joetike. Nëse zbulojmë raste të tilla, ky website do të marrë masa parandaluese si paralajmërim, kufizim tregtimi, mbyllje llogarie, etj. Ne nuk mbajmë përgjegjësi për këto raste dhe ruajmë të drejtën të ndjekim penalisht përgjegjësit.",
        content16: "I. Dispozitat e përgjithshme",
        content17: "1.1 “Marrëveshja e Përdoruesit” (më poshtë quajtur “Marrëveshja” ose “Këto Kushte dhe Rregulla”), përbëhet nga teksti kryesor, “Politika e Privatësisë”, “Njih klientin tënd dhe Politika kundër pastrimit të parave” si dhe çdo rregull, deklaratë ose shpjegim tjetër i publikuar nga ky website.",
        content18: "1.2 Para se të përdorni shërbimet e ofruara nga ky website, ju duhet të lexoni me kujdes këtë marrëveshje. Nëse nuk e kuptoni apo keni dyshime, konsultohuni me një avokat profesionist. Nëse nuk pajtoheni me këtë marrëveshje dhe/ose ndryshimet e saj, ndaloni menjëherë përdorimin e shërbimeve ose mos hyni më në këtë website. Hyrja apo përdorimi i çfarëdo shërbimi nënkupton që ju keni lexuar dhe plotësisht pranuar kushtet, përfshirë ndryshimet që mund të bëhen.",
        content19: "1.3 Pasi të plotësoni informacionin e kërkuar dhe procedurat e tjera përkatëse, ju mund të regjistroheni me sukses si anëtar i këtij website. Duke klikuar butonin “Pranoj” gjatë regjistrimit, ju nënshkruani këtë marrëveshje në formë elektronike me kompaninë. Çdo përdorim i shërbimeve me klikim të butonit “Pranoj” ose të ngjashëm, apo me ndonjë formë tjetër të pranuar nga ky website, do të konsiderohet si pranim i plotë i kushteve. Mungesa e një nënshkrimi me shkrim nuk ndikon në vlefshmërinë ligjore të kësaj marrëveshjeje.",
        content20: "1.4 Pasi të bëheni anëtar i këtij website, ju do të merrni një llogari dhe një fjalëkalim përkatës. Ju jeni përgjegjës për ruajtjen e tyre dhe për çdo aktivitet të kryer me to.",
        content21: "1.5 Vetëm anëtarët mund të përdorin këtë website për tregti me asete digjitale dhe për shërbimet e tjera të përcaktuara. Vizitorët jo-anëtarë mund të hyjnë vetëm për të parë përmbajtjen publike.",
        content22: "1.6 Duke u regjistruar dhe përdorur çdo shërbim ose funksion të ofruar nga ky website, ju konsideroheni se keni lexuar, kuptuar dhe:",
        content23: "1.6.1 Pranuar të gjitha kushtet e kësaj marrëveshjeje.",
        content24: "1.6.2 Konfirmuar që jeni mbi 18 vjeç ose në moshën ligjore të përcaktuar nga ligjet përkatëse për nënshkrimin e kontratave, dhe që aktivitetet tuaja në këtë website përputhen me ligjet e juridiksionit tuaj, duke patur aftësi të plotë për të pranuar këto kushte dhe për të kryer tregti me asete digjitale.",
        content25: "1.6.3 Garantoni që asetet digjitale të përfshira në tregti janë të fituara ligjërisht dhe i përkasin plotësisht juve.",
        content26: "1.6.4 Pajtoheni të mbani përgjegjësi të plotë për çdo aktivitet tregtar ose jotregtar tuajin dhe çdo fitim ose humbje që lind prej tyre.",
        content27: "1.6.5 Konfirmoni që informacioni i dhënë gjatë regjistrimit është i vërtetë dhe i saktë.",
        content28: "1.6.6 Pajtoheni të respektoni ligjet përkatëse, përfshirë detyrimet tatimore dhe raportimin e fitimeve.",
        content29: "1.6.7 Pajtoheni të mos merrni kurrë pjesë në aktivitete që dëmtojnë interesat e këtij website ose kompanisë, pavarësisht nëse lidhen me shërbimet e ofruara ose jo.",
        content30: "1.6.8 Kjo marrëveshje rregullon vetëm marrëdhënien ligjore ndërmjet nesh dhe jush, por nuk rregullon marrëdhëniet apo mosmarrëveshjet ligjore mes përdoruesve të website-it ose mes jush dhe palëve të tjera gjatë tregtimit të aseteve digjitale.",
        content31: "II. Rishikimi i marrëveshjes",
        content32: "Ne rezervojmë të drejtën të rishikojmë këtë marrëveshje herë pas here dhe ta publikojmë atë në formë njoftimi në website, pa qenë e nevojshme t’ju njoftojmë veçmas. Pas publikimit, ndryshimet hyjnë automatikisht në fuqi. Ju duhet të kontrolloni rregullisht përditësimet. Nëse nuk pajtoheni me ndryshimet, ndaloni përdorimin e shërbimeve. Vazhdimi i përdorimit të shërbimeve nënkupton pranimin e kushteve të reja.",
        content33: "III. Regjistrimi",
        content34: "3.1 Kualifikimi për regjistrim",
        content35: "Ju konfirmoni dhe garantoni: Pasi të përfundoni regjistrimin ose të përdorni shërbimet me një mënyrë tjetër të pranuar nga ky website, ju duhet të jeni një individ, person juridik apo organizatë tjetër me aftësinë ligjore për të nënshkruar këtë marrëveshje dhe për të përdorur shërbimet. Duke klikuar butonin e regjistrimit, ju ose përfaqësuesi juaj i autorizuar pranoni kushtet dhe regjistroheni. Nëse nuk keni këtë kualifikim, atëherë ju dhe përfaqësuesi juaj do të mbani përgjegjësi për pasojat. Kompania ruan të drejtën të mbyllë ose ngrijë përgjithmonë llogarinë tuaj dhe të kërkojë përgjegjësi.",
        content36: "3.2 Qëllimi i regjistrimit",
        content37: "Ju konfirmoni dhe garantoni: regjistrimi juaj nuk ka për qëllim shkeljen e ligjeve apo prishjen e rendit të tregtimit të aseteve digjitale në këtë website.",
        content38: "3.3 Procesi i regjistrimit",
        content39: "3.3.1 Ju pranoni të ofroni adresë email-i të vlefshme, numër telefoni dhe të dhëna të tjera sipas kërkesave të faqes së regjistrimit të përdoruesit të këtij website-i. Ju mund të përdorni email-in, numrin e telefonit që keni ofruar ose konfirmuar, ose mënyra të tjera të lejuara nga ky website si mjet hyrjeje. Nëse kërkohet nga ligjet dhe rregulloret përkatëse të juridiksionit tuaj, ju duhet të ofroni emrin tuaj të vërtetë, dokumentet identifikuese dhe informacione të tjera sipas rregulloreve për privatësinë dhe anti-pastrimin e parave, si dhe t’i përditësoni ato rregullisht, duke qenë të sakta dhe të plota. Ju mbani përgjegjësi për vërtetësinë, plotësinë dhe saktësinë e këtyre të dhënave dhe do të mbani përgjegjësi për çdo humbje apo pasojë të drejtpërdrejtë ose të tërthortë.",
        content40: "3.3.2 Nëse ligjet dhe rregulloret e juridiksionit tuaj kërkojnë regjistrimin me emër të vërtetë të numrave të telefonit, ju pranoni që numri i ofruar për regjistrim është i regjistruar me emër të vërtetë. Çdo humbje apo pasojë e drejtpërdrejtë ose e tërthortë që rezulton nga mosrespektimi i kësaj kërkese do të mbetet përgjegjësi e juaja.",
        content41: "3.3.3 Pasi të keni ofruar në mënyrë të ligjshme, të plotë dhe të vlefshme informacionin e nevojshëm për regjistrim dhe ky informacion të verifikohet, ju fitoni të drejtën për të marrë një llogari dhe fjalëkalim të këtij website-i. Pasi të merrni llogarinë dhe fjalëkalimin, regjistrimi juaj konsiderohet i suksesshëm dhe mund të hyni si anëtar.",
        content42: "3.3.4 Ju pranoni të merrni email-e dhe/ose mesazhe të shkurtra të dërguara nga ky website në lidhje me menaxhimin dhe funksionimin e tij.",
        content43: "IV. Shërbimet",
        content44: "Ky website ju ofron vetëm një platformë tregtare online për aktivitetet tuaja me asete digjitale (përfshirë por jo të kufizuara tek tregtia e aseteve digjitale).",
        content45: "4.1 Përmbajtja e shërbimit",
        content46: "4.1.1 Ju keni të drejtë të shikoni në kohë reale tregjet dhe informacionet e tregtimit për asetet digjitale, si dhe të jepni urdhra tregtimi dhe të përfundoni tregtitë tuaja përmes këtij website-i.",
        content47: "4.1.2 Ju keni të drejtë të shikoni informacionet në llogarinë tuaj të anëtarit dhe të përdorni funksionet e ofruara nga ky website.",
        content48: "4.1.3 Ju keni të drejtë të merrni pjesë në aktivitetet e organizuara nga ky website sipas rregullave të publikuara.",
        content49: "4.1.4 Ky website angazhohet të ofrojë shërbime të tjera sipas premtimeve të tij.",
        content50: "4.2 Rregullat e shërbimit – Ju pranoni të respektoni rregullat e mëposhtme të këtij website-i:",
        content51: "4.2.1 Ju duhet të respektoni ligjet dhe rregulloret përkatëse, duke garantuar ligjshmërinë e burimit të aseteve tuaja digjitale. Nuk lejohet të përdorni shërbimet e këtij website-i për aktivitete të paligjshme apo që dëmtojnë të drejtat e palëve të treta, përfshirë dërgimin ose marrjen e informacionit të paligjshëm, përhapjen e materialeve mashtruese ose çdo lloj informacioni tjetër të dëmshëm, si dhe përdorimin pa leje ose falsifikimin e informacionit të këtij website-i.",
        content52: "4.2.2 Ju duhet të përdorni dhe ruani me kujdes llogarinë tuaj, fjalëkalimin e hyrjes, fjalëkalimin e fondeve, numrin e telefonit të lidhur me regjistrimin dhe kodet e verifikimit. Ju mbani përgjegjësi të plotë për çdo veprim dhe pasojë që rezulton nga përdorimi i tyre. Nëse kuptoni se llogaria, fjalëkalimi ose kodi juaj i verifikimit është përdorur pa autorizim, duhet të njoftoni menjëherë këtë website për të pezulluar llogarinë. Ky website ka të drejtë të marrë masa brenda një kohe të arsyeshme, por nuk mban përgjegjësi për pasojat që ndodhin përpara marrjes së masave.",
        content53: "4.2.3 Ju pranoni të mbani përgjegjësi për të gjitha aktivitetet që ndodhin nën llogarinë dhe fjalëkalimin tuaj (përfshirë publikimin e informacionit, nënshkrimin e marrëveshjeve online, blerjen e shërbimeve etj.).",
        content54: "4.2.4 Ju nuk duhet të pengoni me dashje tregtinë e aseteve digjitale, të prishni rendin e tregtisë apo të pengoni funksionimin normal të këtij website-i. Nuk lejohet të përdorni mjete teknike ose metoda të tjera për të ndikuar negativisht mbi sistemin ose për të dëmtuar reputacionin e website-it.",
        content55: "4.2.5 Nëse lindin mosmarrëveshje tregtare me përdorues të tjerë, nuk lejohet të kërkoni nga ky website ofrimin e të dhënave përmes mjeteve jashtë juridiksionit gjyqësor ose administrativ.",
        content56: "4.2.6 Gjatë përdorimit të shërbimeve të këtij website-i, çdo taksë apo tarifë e lidhur me pajisje, softuer apo shërbime të tjera mbetet përgjegjësi e juaja.",
        content57: "4.2.7 Ju duhet të respektoni këtë marrëveshje dhe çdo rregull tjetër të publikuar ose përditësuar nga ky website. Ju keni të drejtë të ndaloni përdorimin e shërbimeve në çdo kohë.",
        content58: "4.3 Rregullat e produkteve",
        content59: "4.3.1 Shikimi i informacionit të tregtisë",
        content60: "Kur shikoni informacionin e tregtisë, duhet të lexoni me kujdes të gjitha të dhënat përkatëse, përfshirë çmimin, sasinë, tarifat dhe drejtimin e blerjes ose shitjes. Vetëm pasi të keni pranuar plotësisht këtë informacion mund të klikoni për të përfunduar tregtinë.",
        content61: "4.3.2 Shikimi i detajeve të tregtisë",
        content62: "Ju mund të shikoni regjistrat e transaksioneve përmes llogarisë suaj.",
        content63: "V. Të drejtat dhe detyrimet e website-it",
        content64: "5.1 Nëse nuk keni kualifikimet e përcaktuara për regjistrim, ky website ka të drejtë të refuzojë regjistrimin tuaj ose të mbyllë llogarinë tuaj ekzistuese. Ne ruajmë të drejtën të kërkojmë përgjegjësi nga ju ose përfaqësuesi juaj i autorizuar. Gjithashtu, ky website ruan të drejtën të vendosë në çdo rast nëse do të pranojë regjistrimin tuaj.",
        content65: "5.2 Nëse ky website, sipas gjykimit të tij, vlerëson se ju ose llogaritë tuaja të lidhura nuk jeni të përshtatshëm për investime me rrezik të lartë, ai ka të drejtë të pezullojë ose mbyllë llogarinë tuaj dhe llogaritë e lidhura.",
        content66: "5.3 Nëse zbulohet që përdoruesi i llogarisë nuk është regjistruesi fillestar, ky website ka të drejtë të pezullojë ose mbyllë llogarinë.",
        content67: "5.4 Nëse përmes kontrollit teknik ose verifikimit manual ky website dyshon se informacioni i ofruar është i pasaktë ose i paplotë, ai ka të drejtë t’ju kërkojë korrigjimin ose përditësimin e tij, ose të pezullojë/mbyllë shërbimet përkatëse.",
        content68: "5.5 Ky website ka të drejtë të korrigjojë çdo informacion që përmban gabime të dukshme.",
        content69: "5.6 Ky website rezervon të drejtën të ndryshojë, pezullojë ose ndalojë shërbimet në çdo kohë, pa qenë e nevojshme të njoftojë paraprakisht. Ndalimi i shërbimeve hyn në fuqi në datën e shpalljes së njoftimit në website.",
        content70: "5.7 Ky website do të marrë masa teknike dhe menaxheriale për të garantuar funksionimin normal dhe për të siguruar një mjedis tregtar të qëndrueshëm dhe të sigurt për tregtimin e aseteve digjitale.",
        content71: "5.8 Nëse nuk përdorni llogarinë tuaj për një vit, ky website ka të drejtë ta mbyllë atë dhe të lëshojë emrin e përdoruesit për regjistrim nga të tjerë.",
        content72: "5.9 Ky website do të përmirësojë masat teknike dhe mbrojtjen e sigurisë për të ruajtur asetet tuaja digjitale dhe do t’ju njoftojë nëse ekziston ndonjë rrezik i parashikueshëm sigurie.",
        content73: "5.10 Ky website ka të drejtë të fshijë çdo përmbajtje që shkel ligjin ose rregullat e tij pa qenë e nevojshme të njoftojë paraprakisht.",
        content74: "5.11 Ky website ka të drejtë, sipas ligjeve dhe rregullave të juridiksionit tuaj, të kërkojë më shumë informacion ose dokumente dhe të marrë masa për të respektuar normat përkatëse. Në raste të tilla, ju jeni të detyruar të bashkëpunoni. Gjithashtu, ky website mund të pezullojë ose ndalojë shërbimet për ju.",
        content75: "5.12 Ky website rezervon të drejtën të mbyllë llogarinë tuaj pas një njoftimi paraprak prej shtatë ditësh pune. Ju keni shtatë ditë kohë për të anuluar porositë dhe mbyllur pozicionet. Nëse nuk e bëni, ky website do t’i mbyllë ato me detyrim dhe do t’ju kthejë asetet e mbetura.",
        content76: "5.13 Për të mbrojtur interesat e tregtarëve, ky website ka të drejtë që në rrethana të veçanta (si defekte të sistemit, probleme rrjeti ose tregje ekstreme) të bëjë rregullime mbi produktet, si p.sh. zgjidhje të parakohshme të kontratave. Njoftimet përkatëse do të publikohen në website.",
        content77: "VI. Dëmshpërblimi",
        content78: "6.1 Në çdo rast, përgjegjësia jonë për dëmshpërblim nuk do të kalojë shumën totale të tarifave të shërbimit që kemi mbledhur nga ju për një periudhë tre (3) mujore përdorimi të këtij website-i.",
        content79: "6.2 Nëse ju shkelni këtë marrëveshje ose ndonjë ligj/rregull tjetër, ju duhet të na dëmshpërbleni me të paktën 2 milionë USD dhe të mbuloni të gjitha shpenzimet e lidhura (p.sh. tarifat ligjore). Nëse kjo shumë nuk është e mjaftueshme për të mbuluar humbjet reale, ju duhet ta plotësoni diferencën.",
        content80: "VII. E drejta për të kërkuar masa ndaluese",
        content81: "Ne dhe ju pranojmë që mjetet juridike të zakonshme mund të mos jenë të mjaftueshme në rastet e shkeljes ose rrezikut të shkeljes nga ana juaj. Prandaj, ne kemi të drejtë të kërkojmë masa ndaluese dhe çdo mjet tjetër juridik të lejuar nga ligji ose parimet e barazisë.",
        content82: "VIII. Kufizimi i përgjegjësisë dhe përjashtimet",
        content83: "8.1 Ju e kuptoni dhe pranoni që, në asnjë rast, ne nuk mbajmë përgjegjësi për:",
        content84: "8.1.1 Humbjen e të ardhurave;",
        content85: "8.1.2 Humbjen e fitimit nga tregtia ose kontratat;",
        content86: "8.1.3 Humbjen nga ndërprerja e aktivitetit;",
        content87: "8.1.4 Humbjen e kursimeve të pritura;",
        content88: "8.1.5 Humbjen për shkak të problemeve të informacionit;",
        content89: "8.1.6 Humbjen e mundësive, reputacionit ose besimit;",
        content90: "8.1.7 Humbjen ose dëmtimin e të dhënave;",
        content91: "8.1.8 Kostoja e blerjes së produkteve ose shërbimeve zëvendësuese;",
        content92: "8.1.9 Çdo humbje ose dëm indirekt, i veçantë ose rastësor i shkaktuar nga shkelja e të drejtave (përfshirë neglizhencën), shkelja e kontratës ose ndonjë shkak tjetër, pavarësisht nëse kjo humbje apo dëm mund të ishte parashikuar nga ne ose jo, dhe pavarësisht nëse kemi qenë të njoftuar paraprakisht për mundësinë e një humbjeje ose dëmi të tillë.",
        content93: "8.1.1 deri 8.1.9 janë dispozita të pavarura nga njëra-tjetra.",
        content94: "8.2 Ju e kuptoni dhe pranoni që ne nuk mbajmë përgjegjësi për dëmet që lidhen me rrethanat e mëposhtme:",
        content95: "8.2.1 Kur transaksionet tuaja përmbajnë shkelje të rënda të ligjit ose kontratës.",
        content96: "8.2.2 Kur sjellja juaj në këtë website dyshohet të jetë e paligjshme ose joetike.",
        content97: "8.2.3 Kostot dhe humbjet që lindin nga blerja, marrja e të dhënave, informacionit ose kryerja e tregtive përmes shërbimeve të këtij website-i.",
        content98: "8.2.4 Keqkuptime tuaja mbi shërbimet e këtij website-i.",
        content99: "8.2.5 Çdo humbje tjetër që lidhet me shërbimet e këtij website-i por që nuk është shkaktuar nga ne.",
        content100: "8.3 Ne nuk mbajmë përgjegjësi për ndonjë humbje të shkaktuar nga mirëmbajtja e pajisjeve të rrjetit, dështimi i lidhjes së rrjetit, problemet e kompjuterit, komunikimit ose sistemeve të tjera, dështimi i energjisë, moti, aksidentet, grevat, trazirat, kryengritjet, mungesa e burimeve prodhuese, zjarret, përmbytjet, stuhitë, shpërthimet, luftërat, shkaqet e bankave ose partnerëve, kolapsi i tregut të aseteve digjitale, veprimet qeveritare, urdhrat e organeve gjyqësore ose administrative, apo faktorë të tjerë jashtë kontrollit tonë. Ne nuk mbajmë përgjegjësi për vonesa apo ndërprerje shërbimi që lidhen me këto raste.",
        content101: "8.4 Ne nuk garantojmë që të gjitha informacionet, programet dhe tekstet në këtë website janë plotësisht të sigurta dhe të mbrojtura nga viruse ose programe të dëmshme. Prandaj, hyrja dhe përdorimi i shërbimeve ose shkarkimi i programeve është vendim i juaji dhe ju mbani rrezikun dhe humbjet e mundshme.",
        content102: "8.5 Ne nuk japim asnjë garanci për informacionet, produktet apo shërbimet e faqeve të palëve të treta të lidhura në këtë website. Nëse përdorni shërbimet apo produktet e ofruara nga faqe të palëve të treta, kjo mbetet zgjedhja dhe përgjegjësia juaj.",
        content103: "8.6 Ne nuk japim asnjë garanci të shprehur apo të nënkuptuar për shërbimet e këtij website-i, përfshirë por jo të kufizuara tek përshtatshmëria, vazhdimësia, saktësia, besueshmëria ose përshtatja për një qëllim të caktuar. Gjithashtu, ne nuk garantojmë vlefshmërinë, cilësinë, stabilitetin ose plotësinë e teknologjisë dhe informacionit të përfshirë. Përdorimi i shërbimeve është zgjedhje e juaja dhe ju mbani rrezikun dhe humbjet e mundshme. Ne nuk japim garanci për tregun, vlerën apo çmimin e aseteve digjitale. Ju e kuptoni që tregu i aseteve digjitale është i paqëndrueshëm dhe çmimet mund të luhaten ndjeshëm ose të bien, dhe se tregtimi është zgjedhja juaj personale dhe përgjegjësia juaj.",
        content104: "8.7 Garancitë dhe premtimet e përcaktuara në këtë marrëveshje janë të vetmet garanci dhe premtime që japim lidhur me këtë marrëveshje dhe shërbimet e këtij website-i, dhe zëvendësojnë çdo garanci tjetër të shkruar ose gojore, të shprehur ose të nënkuptuar.",
        content105: "8.8 Ne nuk heqim dorë nga asnjë e drejtë ligjore për kufizimin ose përjashtimin e përgjegjësisë sonë për dëmshpërblim, përveç rasteve kur është specifikuar ndryshe në këtë marrëveshje.",
        content106: "8.9 Pasi regjistroheni, ju pranoni çdo veprim të bërë nga ne sipas kësaj marrëveshjeje dhe mbani përgjegjësi për çdo rrezik që lind prej tyre.",
        content107: "IX. Përfundimi i marrëveshjes",
        content108: "9.1 Ky website ka të drejtë të ndërpresë të gjitha shërbimet sipas kësaj marrëveshjeje. Marrëveshja përfundon ditën kur ndërpriten të gjitha shërbimet.",
        content109: "9.2 Pas përfundimit të kësaj marrëveshjeje, ju nuk keni të drejtë të kërkoni që ky website të ofrojë më tej shërbime ose detyrime të tjera, përfshirë ruajtjen apo publikimin e informacionit në llogarinë tuaj, apo përcjelljen e mesazheve tek ju ose palë të treta.",
        content110: "9.3 Përfundimi i kësaj marrëveshjeje nuk ndikon tek të drejtat e palës që nuk ka shkelur marrëveshjen për të kërkuar përgjegjësi nga pala shkelëse.",
        content111: "X. Të drejtat e pronësisë intelektuale",
        content112: "10.1 Të gjitha produktet e pronësisë intelektuale të përfshira në këtë website, duke përfshirë logon, bazat e të dhënave, dizajnin e faqes, tekstet, grafikat, softuerin, fotot, videot, muzikën, zërin dhe kombinimet e tyre, si dhe kodin burimor dhe programet, i përkasin këtij website-i. Ju nuk mund t’i kopjoni, ndryshoni ose përdorni këto përmbajtje për qëllime tregtare.",
        content113: "10.2 Të gjitha të drejtat mbi emrin e këtij website-i (përfshirë por jo të kufizuara tek marka dhe logoja) i përkasin kompanisë.",
        content114: "10.3 Duke pranuar këtë marrëveshje, ju i transferoni falas dhe ekskluzivisht këtij website-i të gjitha të drejtat e autorit mbi çdo informacion të publikuar prej jush, përfshirë por jo të kufizuara tek të drejtat e kopjimit, shpërndarjes, qirasë, shfaqjes, performancës, transmetimit, prodhimit, adaptimit, përkthimit, përpilimit, etj. Ky website ka të drejtë të ndjekë penalisht shkelësit dhe të përfitojë çdo kompensim. Ky dispozitiv vlen për çdo përmbajtje të mbrojtur nga ligji i të drejtave të autorit të publikuar nga ju, qoftë para ose pas hyrjes në fuqi të kësaj marrëveshjeje.",
        content115: "10.4 Gjatë përdorimit të shërbimeve të këtij website-i, nuk mund të përdorni ose të shfrytëzoni në mënyrë të paligjshme të drejtat e pronësisë intelektuale të këtij website-i ose të palëve të treta. Ju nuk mund të publikoni ose autorizoni publikimin e informacionit të publikuar në këtë website në faqe të tjera ose media.",
        content116: "XI. Mbrojtja e informacionit",
        content117: "Vlen sipas “Politikës së Privatësisë” të publikuar veçmas nga ky website.",
        content118: "XII. Llogaritjet",
        content119: "Të gjitha rezultatet e llogaritjeve të transaksioneve janë verifikuar nga ne dhe metodat e llogaritjes janë publikuar në website, por nuk garantojmë që përdorimi i website-it nuk do të ndërpritet ose nuk do të ketë gabime.",
        content120: "XIII. Kontrolli i eksportit",
        content121: "Ju e kuptoni dhe pranoni që, sipas ligjeve përkatëse, nuk mund të eksportoni, ri-eksportoni, importoni ose transferoni ndonjë material nga ky website (përfshirë softuerin). Ju garantoni që nuk do të kryeni ose ndihmoni ndonjë aktivitet që shkel ligjet përkatëse të eksportit ose rregulloret e tjera të zbatueshme. Nëse ndodhin raste të tilla, ju duhet të na njoftoni menjëherë dhe të na ndihmoni për t’i trajtuar.",
        content122: "XIV. Transferimi",
        content123: "Të drejtat dhe detyrimet e përcaktuara në këtë marrëveshje vlejnë edhe për pasardhësit, trashëgimtarët, ekzekutorët dhe administratorët. Ju nuk mund t’i transferoni ato tek një palë e tretë pa pëlqimin tonë, por ne mund t’i transferojmë në çdo kohë tek një palë e tretë duke ju njoftuar.",
        content124: "XV. Ndarshmëria",
        content125: "Nëse ndonjë dispozitë e kësaj marrëveshjeje shpallet e pazbatueshme, e pavlefshme ose e paligjshme nga ndonjë gjykatë kompetente, kjo nuk ndikon tek vlefshmëria e dispozitave të tjera.",
        content126: "XVI. Marrëdhënia jo-agjencore",
        content127: "Asnjë dispozitë e kësaj marrëveshjeje nuk krijon ose sugjeron një marrëdhënie agjencie, kujdestarie apo përfaqësie mes nesh dhe jush, përveç rasteve të përcaktuara shprehimisht.",
        content128: "XVII. Heqja dorë",
        content129: "Heqja dorë nga ndjekja e përgjegjësisë për një shkelje nuk nënkupton heqje dorë për shkelje të tjera. Mos ushtrimi i një të drejte ose mjeti juridik nuk interpretohet si heqje dorë prej tij.",
        content130: "XVIII. Titujt",
        content131: "Të gjitha titujt përdoren vetëm për lehtësim dhe nuk kufizojnë apo zgjerojnë përmbajtjen e dispozitave të marrëveshjes.",
        content132: "XIX. Ligji i zbatueshëm",
        content133: "19.1 Përpara ngritjes së ndonjë padie ose pretendimi, ju pranoni të kontaktoni këtë website përmes email-it për të zgjidhur mosmarrëveshjet në mënyrë joformale. Ne do të përpiqemi t’i zgjidhim brenda kompanisë. Palët pranojnë të negociojnë me mirëbesim (diskutimet do të jenë konfidenciale dhe nuk do të përdoren si prova në gjykatë).",
        content134: "19.2 Ju pranoni që çdo mosmarrëveshje, përfshirë vlefshmërinë, interpretimin, zbatimin ose përfundimin e kësaj marrëveshjeje, do t’i nënshtrohet arbitrazhit të Dhomës Ndërkombëtare të Tregtisë (ICC) sipas Rregullave të saj në fuqi. Vendi i arbitrazhit do të jetë Belize dhe ligji i zbatueshëm përcaktohet sipas rregullave të ICC-së. Përveç nëse palët bien dakord ndryshe, arbitri i vetëm do të caktohet sipas Rregullave të ICC-së. Arbitri ka autoritetin ekskluziv për të vendosur mbi juridiksionin e tij, përfshirë vlefshmërinë e marrëveshjes së arbitrazhit dhe arbitrueshmërinë e kërkesave. Arbitrazhi do të zhvillohet në gjuhën angleze dhe vendimi i arbitrit do të jetë përfundimtar dhe detyrues, i zbatueshëm në çdo gjykatë kompetente.",
        content135: "XX. Hyrja në fuqi dhe interpretimi",
        content136: "20.1 Kjo marrëveshje hyn në fuqi kur ju klikoni pranimin në faqen e regjistrimit dhe plotësoni procedurën e regjistrimit, duke marrë një llogari dhe fjalëkalim. Ajo është detyruese për të dyja palët.",
        content137: "20.2 E drejta përfundimtare e interpretimit të kësaj marrëveshjeje i takon këtij website-i.",
        content138: "Politika Njih Klientin Tënd dhe Anti-Pastrimit të Parave",
        content139: "I. Hyrje",
        content140: "1.1 Ne garantojmë që do të zbatojmë me kujdes ligjet dhe rregulloret për 'Njih Klientin Tënd' dhe anti-pastrimin e parave dhe nuk do të shkelim me qëllim këtë politikë. Brenda kufijve të arsyeshëm të kontrollit tonë, ne do të marrim masa dhe teknologji të nevojshme për t’ju ofruar shërbime të sigurta dhe për t’ju mbrojtur sa më shumë nga humbjet që mund të shkaktohen nga veprimet e paligjshme të pastrimit të parave.",
        content141: "1.2 Politika jonë për Njih Klientin Tënd dhe anti-pastrimin e parave është një sistem gjithëpërfshirës ndërkombëtar, i cili përfshin politikat përkatëse të juridiksioneve të ndryshme ku ju i përkisni.",
        content142: "II. Politikat për Njih Klientin Tënd dhe anti-pastrimin e parave janë si më poshtë:",
        content143: "2.1 Publikimi dhe përditësimi i vazhdueshëm i politikave për Njih Klientin Tënd dhe anti-pastrimin e parave për të përmbushur standardet ligjore dhe rregullatore;",
        content144: "2.2 Publikimi dhe përditësimi i parimeve udhëzuese dhe rregullave për funksionimin e këtij website-i, dhe stafi ynë do të ofrojë shërbime në përputhje me këto parime dhe rregulla;",
        content145: "2.3 Hartimi dhe zbatimi i procedurave të brendshme për monitorimin dhe kontrollin e transaksioneve, duke përfshirë verifikimin e rreptë të identitetit dhe krijimin e një ekipi profesional përgjegjës për çështjet e anti-pastrimit të parave;",
        content146: "2.4 Përdorimi i një qasjeje të bazuar në rrezik për të kryer kujdesin e duhur ndaj klientëve dhe monitorimin e vazhdueshëm;",
        content147: "2.5 Rishikimi dhe kontrollimi periodik i transaksioneve të kryera;",
        content148: "2.6 Raportimi i transaksioneve të dyshimta tek autoritetet kompetente;",
        content149: "2.7 Dokumentet e identifikimit, dokumentet e provës së adresës dhe regjistrat e transaksioneve do të ruhen për të paktën gjashtë vjet dhe, nëse kërkohen nga autoritetet rregullatore, mund të dorëzohen pa ju njoftuar veçmas.",
        content150: "III. Informacioni i identitetit dhe verifikimi",
        content151: "3.1 Informacioni i identitetit",
        content152: "3.1.1 Sipas juridiksioneve dhe llojit të subjektit, informacioni që mbledhim mund të ndryshojë. Në parim, nga individët që regjistrohen kërkojmë informacionin e mëposhtëm:",
        content153: "Informacioni bazë personal: emri, adresa (dhe adresa e përhershme, nëse ndryshon), data e lindjes dhe shtetësia, si dhe çdo të dhënë tjetër e mundshme. Verifikimi i identitetit duhet të bëhet përmes dokumenteve zyrtare ose të lëshuara nga institucione autoritative, si pasaportë, kartë identiteti ose dokumente të tjera sipas kërkesave të juridiksioneve përkatëse. Adresa e ofruar duhet të verifikohet me metoda të përshtatshme, si kontrolli i faturave të transportit, faturave të shërbimeve ose regjistrave të votuesve.",
        content154: "Një fotografi e vlefshme: përpara regjistrimit, ju duhet të ofroni një fotografi ku mbani dokumentin tuaj të identitetit pranë gjoksit;",
        content155: "Të dhëna kontakti: numri i telefonit dhe/ose një adresë email-i e vlefshme.",
        content156: "3.1.2 Nëse jeni kompani ose subjekt tjetër juridik, do të mbledhim informacionin e mëposhtëm për të identifikuar pronarët përfundimtarë ose përfituesit e llogarive të besimit.",
        content157: "Certifikata e regjistrimit të kompanisë; kopjet e statutit dhe memorandumit të shoqërisë; dokumente që provojnë strukturën e aksioneve dhe pronësinë; vendimet e bordit që autorizojnë hapjen dhe përdorimin e llogarisë; dokumente identifikimi të drejtorëve, aksionarëve kryesorë dhe personave të autorizuar për të nënshkruar mbi llogarinë; adresa kryesore e biznesit, dhe nëse ndryshon nga adresa postare, duhet ofruar kjo e fundit. Nëse adresa vendore nuk përputhet me adresën kryesore të biznesit, klienti konsiderohet me rrezik të lartë dhe duhet të ofrojë dokumente shtesë.",
        content158: "Sipas juridiksioneve dhe llojit të subjektit, mund të kërkohen dokumente të tjera të lëshuara nga autoritetet kompetente ose çdo dokument tjetër që ne e konsiderojmë të nevojshëm.",
        content159: "3.1.3 Ne pranojmë vetëm versione në anglisht ose kinezisht të dokumenteve të identitetit. Nëse nuk janë në këto gjuhë, ato duhet të përkthehen në anglisht dhe të noterizohen.",
        content160: "3.2 Verifikimi",
        content161: "3.2.1 Ju duhet të ofroni të gjitha faqet e dokumenteve të identifikimit.",
        content162: "3.2.2 Ju duhet të ofroni një fotografi ku mbani dokumentin tuaj të identitetit pranë gjoksit.",
        content163: "3.2.3 Kopjet e dokumenteve duhet të krahasohen me origjinalet. Nëse një person i autorizuar dhe i besueshëm konfirmon që kopja është një version i saktë dhe i plotë i origjinalit, kopja mund të pranohet. Personat e tillë mund të jenë ambasadorë, noterë, gjyqtarë lokalë etj.",
        content164: "3.2.4 Për identifikimin e pronarëve përfundimtarë dhe kontrolluesve të llogarive, duhet përcaktuar se cilët individë zotërojnë ose kontrollojnë klientin direkt dhe/ose transaksionet. Në rastin e kompanive, identiteti i aksionarëve kryesorë (p.sh. ata që zotërojnë 10% ose më shumë të të drejtave të votimit) duhet të verifikohet. Në përgjithësi, zotërimi i 25% të aksioneve konsiderohet rrezik normal dhe identiteti i tyre duhet të verifikohet; zotërimi i 10% ose më shumë konsiderohet rrezik i lartë dhe kërkon verifikim më të rreptë.",
        content165: "IV. Monitorimi i transaksioneve",
        content166: "4.1 Ne vendosim dhe rregullojmë kufijtë maksimalë ditorë për tregti dhe tërheqje bazuar në sigurinë dhe situatën reale të tregtisë;",
        content167: "4.2 Nëse një përdorues kryen transaksione tepër të shpeshta ose në mënyrë të pazakontë, ekipi ynë profesional do të vlerësojë dhe vendosë nëse ato janë të dyshimta;",
        content168: "4.3 Nëse ne vlerësojmë një transaksion si të dyshimtë, mund të marrim masa kufizuese si pezullimi ose refuzimi i tij, madje të përpiqemi ta kthejmë mbrapsht transaksionin, dhe ta raportojmë menjëherë tek autoritetet përkatëse, por pa ju njoftuar;",
        content169: "4.4 Ne rezervojmë të drejtën të refuzojmë regjistrimin e personave nga juridiksione që nuk përmbushin standardet ndërkombëtare kundër pastrimit të parave ose të personave të konsideruar figura publike politike. Ne gjithashtu rezervojmë të drejtën të pezullojmë ose ndërpresim çdo transaksion të dyshimtë sipas gjykimit tonë, pa u konsideruar se shkelim ndonjë detyrim apo përgjegjësi ndaj jush.",
    },
    register: {
        formTitle1: "Krijo",
        formTitle2: "Regjistrohuni duke përdorur email-in ose numrin tuaj të telefonit",
        formTitle3: "Llogaria",
        field1: "Kodi i verifikimit",
        field2: "Merr",
        field3: "Konfirmo fjalëkalimin",
        field4: "Kodi i ftesës",
        field41: "(opsionale)",
        field5: "Kam lexuar dhe pranoj",
        field6: "Kushtet e Shërbimit",
        placeholder1: "Ju lutemi shkruani kodin e verifikimit",
        content7: "Ju lutemi shkruani kodin e verifikimit",
        content12: "Ju lutemi shkruani numrin e telefonit",
        content13: "Ju lutemi shkruani fjalëkalimin",
        content14: "Ju lutemi shkruani email-in",
        content18: "Ju lutemi shkruani përsëri fjalëkalimin",
        content19: "Ju lutemi pranoni Kushtet e Shërbimit",
        content20: "Ju lutemi shkruani kodin e saktë të verifikimit",
        content23: "Ende nuk keni marrë kodin e verifikimit?",
        content24: "Ju lutemi shkruani kodin e mëposhtëm",
        registerSuccess: "Regjistrimi u krye me sukses",
        content25: "Fjalëkalimet nuk përputhen",
        content26: "Ju lutemi shkruani një adresë email-i të saktë",
        content27: "Rivendosja e fjalëkalimit u krye me sukses"
    },
    download: {
        content1: "Tregto, kudo dhe kurdo",
        content2: "Përshtatje perfekte në shumë pajisje, duke plotësuar nevojat e tregtisë në çdo situatë",
        content3: "Shikoni në çdo kohë tregjet në kohë reale",
        content4: "Bleni dhe shisni lehtësisht BTC, ETH, XRP dhe asete të tjera digjitale",
        content5: "Merrni paralajmërime për ndryshimet e çmimeve të kriptomonedhave që ju interesojnë",
        content6: "Shikoni çmimet e Bitcoin në tregun spot, futures dhe opsione",
        content7: "Krahasoni çmimet e kriptomonedhave nëpër bursa të ndryshme",
        title: "Shkarko",
        install: "Udhëzime instalimi",
        one: "1. Lejoni shkarkimin e profilit të përshkrimit",
        two: "2. Profili i përshkrimit është shkarkuar",
        three: "3. Hyni te 【Cilësimet】 në telefon dhe gjeni 【Të përgjithshme】",
        four: "4. Profili i përshkrimit dhe Menaxhimi i pajisjes",
        five: "5. Klikoni mbi këtë profil",
    },
    identity: {
        noAuthentication: {
            title: "Verifikimi Fillestar",
            pleaseSelectYourCountry: "Ju lutemi zgjidhni vendin tuaj",
            name: "Emri",
            enterName: "Ju lutemi shkruani emrin tuaj",
            city: "Qyteti",
            enterCity: "Ju lutemi shkruani qytetin tuaj",
            IDNumber: "Numri i dokumentit",
            enterIDNumber: "Ju lutemi shkruani numrin e dokumentit tuaj",
        },
        noAdvancedAuthentication: {
            title: "Verifikimi i Avancuar",
            infoCountry: "Vendi/Rajoni",
            infoName: "Emri",
            infoNumber: "Numri i dokumentit",
            infoAddress: "Adresa",
        },
        text: "Jo i verifikuar",
        recertification: "Rivendos verifikimin",
        certification: "Verifikim",
        authenticationInProgress: "I verifikuar",
        inAuthentication: "Në proces verifikimi",
        uploadTheFrontOfTheDocument: "Ngarkoni anën e përparme të dokumentit",
        uploadTheReverseSideOfTheDocument: "Ngarkoni anën e pasme të dokumentit",
        uploadAPhotoOfAHandHeldID: "Ngarkoni një foto duke mbajtur dokumentin",
        pleaseUpload: "Ju lutemi ngarkoni",
        pleaseCompleteOrdinaryCertificationFirst: "Duhet të prisni miratimin e verifikimit fillestar",
        refused: "E refuzuar",
        reason: "Arsyeja",
        succeeded: "E suksesshme",
        uploading: "Duke u ngarkuar",
        newTitle: "Zgjidhni vendin/rajonin e lëshimit të dokumentit tuaj",
        pleaseOrdinaryCertificationFirst: "Ju lutemi përfundoni fillimisht verifikimin fillestar",
        text1: "Ndrysho foton e profilit",
        text2: "Nofka",
        text3: "Llogaria",
        text4: "Ndryshimi i nofkës",
        text5: "Nofka e re",
        text6: "Shkruani nofkën e re",
        text7: "Fjalëkalimi i vjetër",
        text8: "Shkruani fjalëkalimin e vjetër",
        text9: "Fjalëkalimi i ri",
        text10: "Shkruani fjalëkalimin e ri",
        text11: "Konfirmo fjalëkalimin",
        text12: "Shkruani përsëri fjalëkalimin e ri",
        text13: "Email i ri",
        text14: "Kodi i verifikimit",
        text15: "Ju lutemi shkruani kodin e verifikimit",
        text16: "Numri juaj i telefonit",
        text17: "Numri i ri i telefonit",
        text18: "Ju lutemi shkruani numrin tuaj të telefonit",
        text19: "Kodi i verifikimit të telefonit",
        text20: "Verifikimi fillestar",
        text21: "Ju lutemi verifikoni informacionin tuaj të identitetit",
        text22: "Vendi",
        text23: "Qyteti",
        text24: "Shkruani qytetin tuaj",
        text25: "Shkruani emrin tuaj",
        text26: "Numri i dokumentit tuaj",
        text27: "Shkruani numrin e dokumentit tuaj",
        text28: "Foto e përparme e dokumentit",
        text29: "Klikoni për të ngarkuar dokumentin tuaj",
        text30: "Ringarko",
        text31: "Ngarko",
        text32: "Foto e pasme e dokumentit",
        text33: "Klikoni për të ngarkuar anën e pasme të dokumentit",
        text34: "Ju tashmë keni lidhur Google Authenticator",
        text35: "Çelësi",
        text36: "Ju lutemi shkruani kodin nga Google Authenticator",
        text37: "Dërgo",
        text38: "Nuk mund të jetë bosh",
        text39: "Formati i email-it është i gabuar",
        text40: "Dy fjalëkalimet nuk përputhen",
        text41: "Kopjimi u krye me sukses",
        text42: "Kopjimi dështoi",
        text43: "Ndryshimi i fotos së profilit",
        text44: "Ndryshimi i fjalëkalimit",
        text45: "Lidhja e email-it",
        text46: "Ndryshimi i email-it",
        text47: "Lidhja e telefonit",
        text48: "Ndryshimi i telefonit",
        text49: "Verifikimi Google",
        text50: "Lidh Google Authenticator",
        text51: "Shkruani kodin nga Google Authenticator",
        text52: "Ruaj",
        text53: "Konfirmo dërgimin",
        text54: "Ndrysho",
        text55: "Lidh",
        text56: "Çaktivizo Google Authenticator",
        text57: "Hapi tjetër",
        text58: "Përfunduar",
        text59: "Google Authenticator është lidhur",
        text60: "Google Authenticator është çaktivizuar",
        text61: "Verifikimi fillestar është dorëzuar",
        text62: "Verifikimi i avancuar është dorëzuar",
        text63: "Nuk është ngarkuar asnjë imazh",
        text64: "Ridërgo",
        text65: "Ju lutemi shkruani nofkën",
        text66: "Nofka u ruajt me sukses",
        text67: "Ende nuk është ngarkuar imazh",
        text68: "Ndryshimi i fjalëkalimit u krye me sukses",
        text69: "Ndryshimi i email-it u krye me sukses",
        text70: "Foto e profilit u ruajt me sukses",
        text71: "Ngarko imazhin",
        text72: "Email-i juaj",
        text73: "Shkruani email-in tuaj të ri",
        text74: "Emri juaj",
        text75: "Shko te verifikimi",
        text76: "Ju lutemi verifikoni me një foto të dokumentit të mbajtur në dorë"
    },
    retrievePassword: {
        formTitle1: "Rivendos fjalëkalimin",
        formTitle2: "Për sigurinë e aseteve tuaja, tregtimi është i ndaluar brenda 24 orëve pas ndryshimit të fjalëkalimit.",
        formTitle3: "Rikupero fjalëkalimin",
        formTitle4: "Konfirmo ndryshimin",
        formTitle5: "Ju lutemi shkruani fjalëkalimin e vjetër",
        formTitle6: "Ju lutemi shkruani fjalëkalimin e ri"
    },
    home: {
        title1: "Platforma më e njohur e tregtimit të kriptomonedhave",
        title3: "Pse ",
        title4: " është një platformë blockchain me burim të hapur dhe me performancë të lartë, e krijuar për të mbështetur dhe operuar infrastrukturë digjitale të sigurt, të pajtueshme dhe të parashikueshme.",
        field1: "Bursë me përvojë",
        field2: "Shërbime financiare për asete digjitale",
        field3: "Shkallë përdoruesish me miliona",
        field4: "Krijimi i fondeve të shumta për mbrojtjen e investitorëve",
        field5: "Tregti e shpejtë",
        field6: "CME Group është në gjendje të përputhë porositë me vonesë ultra të ulët për të ofruar përvojën më të mirë tregtare.",
        title5: "Tendencat e tregut",
        title6: "Shiko më shumë",
        table1: "Monedha",
        table2: "Çmimi i fundit",
        table3: "24H Ndryshim",
        table4: "Vëllimi 24H",
        table5: "Vlera e tregtisë 24H",
        table6: "Tregu",
        title7: "Rreth ",
        title8: " angazhohet të ofrojë për përdoruesit mjetet më të avancuara të tregtimit, teknologji inovative dhe shërbim klienti të pakrahasueshëm.",
        title9: "Fusha e aseteve digjitale ndryshon çdo ditë, vetëm me vizion të gjerë dhe përparim të shpejtë mund të ecet në hap me revolucionin teknologjik.",
        title901: " u ofron përdoruesve tanë dhe ofruesve globalë të likuiditetit shërbimet më të avancuara të tregtimit të aseteve digjitale.",
        title10: "Ne besojmë fort që çdo përdorues meriton përvojën më të mirë tregtare.",
        title11: "Siguri e besueshme",
        title12: "Masat tona të avancuara të sigurisë dhe fondi SAFU mbrojnë asetet tuaja digjitale nga të gjitha rreziqet.",
        title13: "Tarifat më të favorshme",
        title14: "Norma tregtare të ulëta, përfitime konkurruese VIP dhe shërbim me cilësi të lartë.",
        title15: "Mbështetje klienti 24*7",
        title16: "Shërbim i vazhdueshëm 24/7 për t’ju ndihmuar menjëherë me çdo konsultim.",
        title17: "Tregti pa komision",
        title18: "Tregtoni kriptomonedha me metoda të shumta pagese, pa komisione, shpejt dhe në mënyrë të sigurt.",
        title19: "Tregtoni kudo, kurdo",
        title20: "Përshtatje perfekte në shumë pajisje, duke përmbushur çdo nevojë tregtare",
        title21: "Shikoni në çdo kohë tregjet në kohë reale",
        title22: "Bleni dhe shisni lehtësisht BTC, ETH, XRP dhe asete të tjera digjitale",
        title23: "Merrni paralajmërime për ndryshimet e çmimeve të kriptomonedhave që ju interesojnë",
        title24: "Shikoni çmimet e Bitcoin në tregun spot, futures dhe opsione",
        title25: "Krahasoni çmimet e kriptomonedhave nëpër bursa të ndryshme",
        title26: "Regjistrohuni tani",
        title27: "USD",
        title28: "Vëllimi i tregtisë 24-orëshe",
        title29: "Ofrues i likuiditetit të përbashkuar",
        title30: "Përdorues",
        title31: "Më shumë",
        title32: "Binance Loan shtoi asetet kolaterale CTSI & KSM dhe prezantoi oferta me ulje interesi për BUSD & USDT!",
        title33: "Avantazhet tona",
        title34: "Siguri dhe stabilitet",
        title35: "Ekip teknik i nivelit të lartë, mbrojtje e plotë e sigurisë, motor tregtimi me shpejtësi të lartë i zhvilluar vetë, funksionim i qëndrueshëm edhe me miliona transaksione të njëkohshme.",
        title36: "Profesional dhe në përputhje me ligjin",
        title37: "Ekip operimi me përvojë shumëvjeçare në blockchain dhe financë, me licenca të ligjshme për tregtim asetesh digjitale dhe 100% garanci të fondeve.",
        title38: "Përdoruesi mbi të gjitha",
        title39: "Për tregun global, mbështetje shumëgjuhëshe, funksionim 24/7, mbështetje e fortë komunitare dhe shërbim profesional klienti.",
        title40: "Performancë e lartë",
        title41: "300,000 transaksione për sekondë, koha e përgjigjes së porosive më pak se 1 milisekondë.",
        title42: "Rreth nesh",
        title43: "Tregtoni kudo",
        title44: "Përshtatje perfekte në shumë pajisje, duke përmbushur çdo nevojë tregtare",
        title45: "(Skano kodin për ta shkarkuar)",
        title46: "Lajmet e kriptomonedhave",
        title47: "Partnerët tanë",
        title48: "Rëniet më të mëdha",
        title49: "Vëllimi i tregtisë 24h",
        title50: "Ndryshimi 24h"
    },
    quotation: {
        marketTrading: "Tregu",
        turnover: "Vëllimi i tregtisë",
        optional: "Të preferuarat",
        contractMarket: "Tregu i kontratave",
        currencyPair: "Çifti i monedhës",
        latestPrice: "Çmimi i mbylljes",
        upsAndDowns: "Ndryshimi %",
        highest: "Më i larti",
        lowest: "Më i ulti",
        transactionAmount: "Vlera e tregtisë",
        operate: "Operacion",
        buy: "Tregto",
        topTurnovers: "Renditja sipas vëllimit",
        topGainers: "Fitimet më të larta",
        tradingPair: "Çifti tregtar",
        buyOrder: "Porositë e blerjes",
        sellOrder: "Porositë e shitjes"
    },
    accountChange: {
        demo: "Simulim",
        realAccount: "Llogari reale",
        demoAccount: "Llogari demo",
        accountRole: "Roli i llogarisë",
        pleaseSelect: "Ju lutemi zgjidhni",
        AccountChangeType: "Lloji i ndryshimit të llogarisë",
        AccountType: "Lloji i llogarisë",
        currencyType: "Lloji i monedhës",
        allType: "Të gjitha llojet",
        allAccount: "Të gjitha llogaritë",
        allCoin: "Të gjitha monedhat",
        coin: "Monedha",
        amount: "Shuma e ndryshimit",
        balance: "Bilanci pas ndryshimit",
        time: "Koha",
        title: "Regjistri i ndryshimeve të llogarisë",
        filtrar: "Filtro",
        check: "Kalo te",
        showOnly: "Shfaq vetëm monedhat e mbajtura",
        holdAssets: "Bilanci i aseteve të mbajtura",
        accountList: "Lista e llogarive"
    },
    contractTransaction: {
        chart: "Grafiku",
        basicEdition: "Versioni bazë",
        depthMap: "Harta e thellësisë",
        second: "Sekondë",
        minute: "Minutë",
        day: "Ditë",
        week: "Javë",
        month: "Muaj",
        open: "Hap",
        trade: "Tregti",
        buyLong: "Bli për të gjatë",
        buyShort: "Bli për të shkurtër",
        cannotBuy: "Ky aset nuk mbështet tregtimin e kontratave të dorëzimit",
        cannotBuy1: "Ky aset nuk mbështet tregtimin e përhershëm",
        tradingAssets: "Asetet tregtare",
        amountAvailable: "Sasia në dispozicion",
        timeStr: "Koha",
        transactionPeriod: "Periudha e tregtisë",
        quantity: "Sasia",
        enterQuantity: "Ju lutemi shkruani sasinë",
        buyIn: "Bli gjatë",
        latestTransaction: "Transaksioni i fundit",
        time: "Koha",
        direction: "Drejtimi",
        price: "Çmimi",
        sell: "Shit shkurt",
        positionOrder: "Porositë e dorëzimit",
        historicalOrders: "Porositë historike",
        product: "Produkti",
        realAccount: "(Llogari reale)",
        demoAccount: "(Llogari demo)",
        openingTime: "Koha e hapjes së porosisë",
        openingPrice: "Çmimi i hapjes",
        curretPrice: "Çmimi aktual",
        liquidationPrice: "Çmimi i mbylljes",
        profitOrLoss: "Fitimi ose humbja",
        endTime: "Koha e mbylljes",
        areYouSureToBuy: "A jeni i sigurt që dëshironi të blini?",
        areYouSureToLongBuy: "A jeni i sigurt që dëshironi të blini gjatë?",
        areYouSureToShortBuy: "A jeni i sigurt që dëshironi të blini shkurt?",
        successfullyBought: "Blerja ishte e suksesshme",
        minBuy: "Blerja minimale",
        assets: "Asetet",
        withdraw: "Tërheq",
        entrustedOrder: "Porosi të besuara",
        total: "Totali",
        continueToPlaceOrder: "Vazhdo me porosi",
        orderConfirmation: "Konfirmimi i porosisë",
        buyRu: "Bli",
        sellChu: "Shit",
        areYouSureToSell: "A jeni i sigurt që dëshironi të shisni?",
        operation: "Operacion",
        buyCover: "Mbushje",
        commitSuccess: "Tregtia ishte e suksesshme",
        onlyEnterIntegers: "Lejohet vetëm futja e numrave të plotë",
        trend: "Tendenca",
        lotteryTime: "Afati për porosi",
        countdown: "Numërimi mbrapsht",
        period: "Numri i periudhës",
        cycle: "Cikli kohor",
        unlimited: "Pa kufizim",
        put: "PUT",
        call: "CALL",
        pending: "Në pritje",
        unopened: "Jo e hapur",
        opened: "E hapur",
        settlementPrice: "Çmimi i shlyerjes",
        rateOfReturn: "Norma e kthimit",
        currentPositions: "Pozicionet aktuale",
        positionQuantity: "Sasia e pozicionit",
        guarantee: "Margjina",
        text1: "CALL",
        text2: "PUT",
        text3: "Në pritje për blerje",
        text4: "Sasia e porosisë",
        text5: "Sasia e realizuar",
        text6: "Anulo",
        text7: "Koha e dorëzimit",
        text8: "Kujtesë për anulim",
        text9: "A jeni i sigurt që dëshironi të anuloni porosinë?",
        text10: "Sasia nuk është e vlefshme",
        text11: "Kujtesë për porosi",
        text12: "A jeni i sigurt që dëshironi të blini me opsionin rritje?",
        text13: "A jeni i sigurt që dëshironi të blini me opsionin rënie?",
        text14: "Anulimi u krye me sukses"
    },
    mining: {
        title1: "Platforma udhëheqëse botërore për minierat e aseteve digjitale në blockchain",
		title2: "Transparencë publike · Siguri dhe stabilitet",
		title3: "Ju lutemi zgjidhni monedhën",
		title4: "Norma vjetore e kthimit nga minierat",
		title5: "Ditë",
		title6: "Afati i minierave",
		title7: "Detajet e produktit",
		btn: "Fillo minierën tani",
		btn2: "Mbyll",
		tabs1: "Në proces",
		tabs2: "E shlyer",
		table1: "Emri i produktit",
		table2: "Afati i minierave",
		table3: "Koha e minierave",
		table4: "Shuma e minierave",
		table5: "Koha e skadimit",
		table6: "Fitimi në skadim",
		table7: "Statusi i porosisë",
		egularMining: "Miniera periodike",
		inProgress: "Në proces",
		redeemed: "E shlyer",
		redemption: "Shlyerje",
		regularMining: "Miniera periodike",
		earlyRedemption: "Shlyerje e parakohshme",
		need: "Kërkohet",
		handlingFee: "Komision",
		redemptionConfirmationMessage: "A jeni i sigurt që dëshironi të shlyeni përpara kohe?",
		form1: "Norma vjetore e kthimit nga minierat",
		form2: "Afati i minierave",
		form3: "Monedha e minierave",
		form4: "Shuma e abonimit (minimum/maksimum)",
		form5: "Komisioni për shlyerje të parakohshme: ",
		form6: "Numri i njësive të blera",
		form7: "Fonde të disponueshme",
		form8: "Shuma e blerjes",
		form9: "Fonde të disponueshme",
		form10: "Ju lutemi shkruani shumën e blerjes",
		form11: "Të gjitha",
		form12: "Fitimi i parashikuar",
		form13: "Fonde të pamjaftueshme",
		form14: "Ju lutemi shkruani shumën e blerjes",
		form15: "Porositë e mia",
		form16: "Fitimi",
		form17: "Detajet e porosisë",
		form18: "Shënime për shlyerjen e parakohshme:",
		form19: "Shuma minimale e abonimit",
		form20: "Shuma maksimale e abonimit",
		form21: "Sasia e mbajtur",
		form22: "Koha e blerjes",
		form23: "Koha e shlyerjes",
		form24: "Përfunduar",
		form25: "Abonimi u krye me sukses",
		form26: "Shlyerja u krye me sukses",
		form27: "Investim i lehtë me mbi 25% kthim, më i mirë se tregu, dhe pas blerjes mund të fitoni shpërblime",
		form28: "Ftoni miq për të fituar 50 USDT, dhe kuponët e kontratave mund të kthejnë deri në 20% komision"
    },
    assets: {
        content1: "Asetet e llogarisë",
        content2: "Fitimi i sotëm",
        content3: "Llogaria aktuale",
        content4: "Llogaria reale është pasuria juaj reale që mund të përdoret për tregti dhe tërheqje",
        content5: "Tërheq",
        content6: "Depozito",
        content7: "Këmbe",
        content8: "Transfero",
        content9: "Ju lutemi zgjidhni",
        content10: "Llogari demo",
        content11: "Llogari reale",
        content12: "Merr asete",
        content13: "A jeni i sigurt që dëshironi të kaloni në llogarinë reale?",
        content14: "A jeni i sigurt që dëshironi të kaloni në llogarinë demo?",
        content15: "Marrja ishte e suksesshme",
        table1: "Monedha",
        table2: "Sasia",
        table3: "E ngrirë",
        table4: "Në dispozicion",
        dialog1: "Detajet e produktit",
        dialog2: "1. Ky aset lejohet të përdoret vetëm në modalitetin demo",
        dialog3: "2. Për të parandaluar abuzimin, lejohet vetëm një herë marrje brenda një muaji",
        dialog4: "3. Marrja e aseteve do të shtojë shumën mbi bazën ekzistuese, pa ndryshuar gjendjen e pozicioneve",
        dialog5: "4. Nëse keni pyetje të tjera, ju lutemi kontaktoni shërbimin e klientit",
        dialog6: "Mbyll",
        dialog7: "Merr asete demo menjëherë",
        dialog8: "Transfero brenda",
        dialog9: "Transfero jashtë",
        dialog10: "Ndrysho",
        dialog11: "Vlerësim",
        dialog12: "Asete demo",
        dialog13: "Llogaria ime",
        dialog14: "Asetet totale të llogarisë",
        dialog15: "Përmbledhja e aseteve",
        dialog16: "Vlerësimi total i aseteve",
        dialog17: "Vlerësimi i aseteve",
        dialog18: "Fitimi i sotëm",
        dialog19: "Fonde të ngrira",
        dialog20: "Ju mund të merrni asete demo një herë në muaj",
        dialog21: "Merr",
        dialog22: "Marrja juaj ishte e suksesshme",
        dialog23: "Fitimi i akumuluar 30-ditor",
        dialog24: "Produktet e investimit",
        dialog25: "Investimet e mia",
        dialog26: "Investimet historike",
        dialog27: "Historiku",
        dialog28: "Regjistri i fondeve"
    },
    validator: {
        dialog14: "Verifikuesi",
        dialog15: "Lidh verifikuesin",
        dialog16: "Ndërrimi i verifikuesit",
        dialog17: "Kodi i verifikimit",
        dialog18: "Kodi QR i verifikuesit",
        dialog19: "Çelësi i verifikuesit",
        dialog20: "Ruaj",
        dialog21: "Ju lutemi zgjidhni verifikuesin",
        dialog22: "Kopjo çelësin",
        dialog23: "U ruajt me sukses",
        dialog24: "Ju lutemi shkruani kodin e verifikimit",
        dialog25: "Këshillë miqësore: Përpara se të konfirmoni ruajtjen, ju lutemi hapni aplikacionin përkatës për të skanuar kodin QR më poshtë ose shtoni manualisht çelësin!",
        dialog26: "Aktivizoni verifikuesin për të ofruar mbrojtjen më të madhe për sigurinë e llogarisë tuaj.",
        dialog27: "Çdo herë që hyni ose tërhiqni fonde, do t’ju duhet të shkruani një kod unik të gjeneruar nga telefoni.",
        dialog28: "Vendosni verifikuesin",
        dialog29: "Ndihmë",
        dialog30: "Ju ende nuk e keni lidhur verifikuesin e identitetit. Me ndihmën e tij do të merrni mbrojtje më të fortë.",
        dialog31: "Aktualisht nuk keni vendosur verifikuesin, ju lutemi vendosni fillimisht",
        dialog32: "Shko te vendosja"
    },
    recharge: {
        title1: "Nuk dini si të përdorni kriptomonedhat për të blerë?",
        title2: "Vetëm tre hapa të thjeshtë!",
        title3: "Zgjidhni kriptomonedhën që dëshironi të blini nga menuja rënëse, pastaj shkruani sasinë ose shumën e blerjes.",
        title4: "Zgjidhni mënyrën tuaj të preferuar të pagesës",
        title5: "Pasi të konfirmoni pagesën, kriptomonedhat e blera do të transferohen automatikisht në llogarinë tuaj.",
        title6: "Ju lutemi zgjidhni monedhën që dëshironi të depozitoni",
        title7: "Regjistri i depozitave",
        table1: "Monedha",
        table2: "Sasia",
        table3: "Emri i zinxhirit",
        table4: "Statusi",
        table5: "Arsyeja",
        table6: "Koha",
        table7: "Shiko vërtetimin",
        dialog1: "Ju lutemi shkruani kodin e mëposhtëm të verifikimit",
        dialog2: "Kodi i pagesës",
        dialog3: "Kopjo",
        dialog4: "Adresa",
        dialog5: "Sasia e depozitimit",
        dialog6: "Pamja e transaksionit",
        dialog7: "Njoftim i rëndësishëm",
        dialog8: "Ju lutemi shkruani sasinë e depozitimit",
        dialog9: "Ngarko imazhin",
        dialog10: "Ju lutemi shkruani përmbajtjen",
        dialog11: "Ju lutemi ngarkoni pamjen e depozitimit",
        dialog12: "Në pritje të shqyrtimit",
        dialog13: "E refuzuar",
        dialog14: "E kreditua",
        tip1: "Dërgimi ishte i suksesshëm",
        tip2: "Kopjimi ishte i suksesshëm",
        tip3: "Kopjimi dështoi",
        tip4: "Ju lutemi zgjidhni monedhën për depozitë",
        tip5: "1. Adresa e mësipërme e depozitimit është adresa zyrtare e platformës, ju lutemi sigurohuni që përdorni adresën zyrtare, humbjet nga gabimet janë përgjegjësi e juaja;",
        tip6: "2. Ju lutemi sigurohuni që kompjuteri dhe shfletuesi juaj të jenë të sigurt për të shmangur ndryshimin ose rrjedhjen e informacionit;",
        tip7: "3. Pas depozitimit në adresën e mësipërme, do të nevojitet konfirmim nga nyjet e rrjetit përpara se të kreditohet;",
        tip8: "4. Ju lutemi sigurohuni që të zgjidhni sistemin dhe monedhën e duhur përpara transferimit. Mos transferoni asete të tjera të palidhura, pasi nuk do të rikthehen.",
        tip9: "Ruaj kodin QR",
        tip10: "Depozito",
        tip11: "Njoftim i rëndësishëm",
        tip12: "Lidhje jashtë platformës",
        tip13: "Kodi QR i depozitimit",
        tip14: "Hapi tjetër",
        tip15: "Regjistri i depozitave",
        tip16: "Detajet e depozitës",
        tip17: "Adresa e depozitimit",
        tip18: "Pagesë e shpejtë",
        tip20: "Bilanci i pamjaftueshëm",
        tip22: "E dërguar, në pritje të konfirmimit",
        tip23: "Në pritje të pagesës",
        tip24: "Shuma",
        tip25: "Pagesa u dërgua, në pritje të konfirmimit të bllokut",
        tip26: "Pagesa u refuzua",
        tip27: "Pagesa dështoi",
        tip28: "Pagesa ishte e suksesshme",
        bankChannel: "Kanal kartelash bankare",
        tip29: "Kërkimet historike",
        tip30: "Lista e monedhave",
        tip31: "Zgjidhni rrjetin",
        tip32: "Kur depozitoni këtë monedhë, përdorni vetëm rrjetet e mbështetura më poshtë. Depozitat përmes rrjeteve të tjera do të shkaktojnë humbje fondesh.",
        tip33: "Kur tërhiqni këtë monedhë, përdorni vetëm rrjetet e mbështetura më poshtë. Tërheqjet përmes rrjeteve të tjera do të shkaktojnë humbje fondesh.",
        tip34: "Depozitim i shpejtë",
        tip35: "Depozitim me skanim",
        tip36: "Depozitim manual",
        tip37: "Rrjeti i depozitimit",

        tip38: "Adresa e depozitimit",
        tip39: "Shuma e depozitimit",
        tip40: "Ngarkimi i mandatit të transaksionit",
        tip41: "Ngarko imazhin",
        tip42: "Konfirmo dërgimin",
        tip43: "Konfirmo pagesën",
        tip44: "Shënim: Ju lutemi konfirmoni adresën e depozitimit, nëse shkruhet gabim dhe shkakton humbje, ne nuk mbajmë përgjegjësi",
        tip45: "Kujtesë",
        tip46: "Adresa u kopjua me sukses!",
        tip47: "Kopjimi i adresës dështoi!",
        tip48: "Bilanci i pamjaftueshëm",
        tip49: "Depozitimi u dërgua me sukses, në pritje të konfirmimit në blockchain",
        tip50: "Depozitimi dështoi",
        tip51: "Shuma e depozitimit është e pasaktë",
        tip52: "Lidhja dështoi",
        tip53: "Portofoli nuk është i lidhur",
        tip54: "Lidhja u refuzua",
        tip55: "Dërguar me sukses, në pritje të miratimit nga shërbimi i klientit",
        tip56: "Ju lutemi ngarkoni pamjen e mandatit të transaksionit",
        tip57: "Dërgimi dështoi",
        tip58: "Regjistri i depozitave",
        tip59: "Regjistri i tërheqjeve",
        tip60: "Monedha e depozitimit",
        tip61: "Monedha e tërheqjes",
        tip62: "Adresa e depozitimit",
        tip63: "Shfaqja e pamjes",
        tip64: "Kliko për të zmadhuar imazhin",
        tip65: "Koha e depozitimit",
        tip66: "Arsyeja e refuzimit",
        tip67: "Shuma e tërheqjes",
        tip68: "Shuma e mbërritur",
        tip69: "Rrjeti i tërheqjes",
        tip70: "Adresa e tërheqjes",
        tip71: "Koha e tërheqjes",
        tip72: "Mbyll",
        tip73: "Pamja e transaksionit",
        tip74: "Në pritje të shqyrtimit",
        tip75: "E refuzuar",
        tip76: "E përfunduar",
        tip77: "E refuzuar",
        tip78: "E shqyrtuar",
        tip79: "Pagesa e dërguar",
        tip80: "Tërhiq",
        tip81: "Rrjeti i transferimit",
        tip82: "Adresa / Mandati",
        tip83: "Tërhiq gjithçka",
        tip84: "Ju lutemi mos tërhiqni direkt në adresat e crowdfunding ose ICO, përndryshe nuk do të merrni tokenët përkatës",
        tip85: "Sasia e mbërritur",
        tip86: "Konfirmo tërheqjen",
        tip87: "Gabim në adresën e tërheqjes",
        tip88: "Gabim në shumën e tërheqjes",
        tip89: "Shuma minimale e tërheqjes është",
        tip90: "Shuma maksimale e tërheqjes është",
        tip91: "Kërkesa për tërheqje është dërguar",
        tip92: "Lista e adresave",
        tip93: "Ende nuk keni shtuar ndonjë adresë",
        tip94: "Shto menjëherë",
        tip95: "Shto adresë",
        tip96: "Shto adresë të re",
        tip97: "Ju lutemi zgjidhni",
        tip98: "Adresa",
        tip99: "Ju lutemi zgjidhni rrjetin e transferimit",
        tip100: "Ju lutemi shkruani adresën",
        tip101: "Adresa u shtua me sukses",
        tip102: "Në proces transaksioni",
    },
    fundExchange: {
        title1: "Si të shkëmbeni fondet?",
        title2: "Zgjidhni monedhën përkatëse që dëshironi të shkëmbeni.",
        title3: "Zgjidhni monedhën përkatëse për shkëmbim.",
        title4: "Shkruani sasinë për shkëmbim dhe pastaj klikoni dërgo për të përfunduar shkëmbimin e fondeve.",
        title5: "Nga",
        title6: "Në",
        title7: "Sasia e shkëmbimit",
        title8: "Kursi i këmbimit",
        title9: "Në dispozicion",
        title10: "Ju lutemi shkruani sasinë për shkëmbim",
        title11: "Nuk ka çift tregtar përkatës për shkëmbim",
        title12: "Ju lutemi shkruani sasinë që dëshironi të shkëmbeni",
        title13: "Shkëmbimi ishte i suksesshëm",
        title14: "Regjistri i shkëmbimeve",
        table1: "Monedha e përdorur",
        table2: "Sasia",
        table3: "Kursi i këmbimit",
        table4: "Monedha e shkëmbyer",
        table5: "Shuma e mbërritur",
        table6: "Koha",
        title15: "Nga",
        title16: "Aktualisht nuk ka fonde të disponueshme, ju lutemi zgjidhni të tjera"
    },
    fundTransfer: {
        title1: "Si të transferoni fondet?",
        title2: "Zgjidhni llogarinë aktuale nga e cila dëshironi të transferoni.",
        title3: "Zgjidhni llogarinë ku dëshironi të transferoni.",
        title4: "Shkruani shumën e transferimit dhe klikoni dërgo për të përfunduar transferimin.",
        title5: "Monedha",
        title6: "Sasia e transferimit",
        title7: "Ju lutemi shkruani shumën që dëshironi të transferoni",
        title8: "Regjistri i transferimeve",
        title9: "Ju lutemi zgjidhni llojin e portofolit",
        title10: "Ju lutemi zgjidhni monedhën",
        title11: "Ju lutemi zgjidhni llojin e portofolit",
        title12: "Ju lutemi zgjidhni monedhën",
        title13: "Ju lutemi shkruani shumën që dëshironi të transferoni",
        title14: "Dërgimi ishte i suksesshëm",
        table1: "Llogaria e daljes",
        table2: "Monedha e transferimit",
        table3: "Sasia e transferimit",
        table4: "Llogaria e hyrjes",
        table5: "Koha",
        table6: "Transfero",
        table7: "Transferimi i fondeve",
        table8: "Transfero tek",
        table9: "Regjistri i transferimeve",
        table10: "Detajet e transferimit",
        table11: "Transferimi ishte i suksesshëm",
        table12: "Transferimi dështoi",
        table13: "Llogaria aktuale nuk lejohet të transferojë"
    },
    withdrawal: {
        title1: "Njoftim i rëndësishëm",
        title2: "1. Për të parandaluar veprimet e arkëtimit të paligjshme, tërheqja e fondeve mund të aplikohet vetëm pasi volumi i tregtisë të arrijë kufirin përkatës.",
        title3: "2. Pas dorëzimit të kërkesës për tërheqje, fondet do të mbërrijnë brenda 24 orëve. Nëse nuk mbërrijnë pas kohës së parashikuar, ju lutemi kontaktoni shërbimin online për ndihmë.",
        title4: "3. Pas dorëzimit të kërkesës për tërheqje, fondet do të kalojnë në gjendje të ngrirë sepse transaksioni është në proces. Këto fonde janë të mbajtura nga sistemi dhe kjo nuk do të thotë që keni humbur asetet tuaja ose ka ndodhur ndonjë anomali.",
        title5: "Monedha",
        title6: "Adresa e portofolit",
        title7: "Shuma e tërheqjes",
        title8: "Regjistri i tërheqjeve",
        title9: "Ju lutemi zgjidhni monedhën",
        title10: "Ju lutemi zgjidhni llojin e zinxhirit",
        title101: "",
        title11: "Ju lutemi shkruani",
        title12: "Adresa e portofolit",
        title13: "Dërgimi ishte i suksesshëm",
        title14: "Në shqyrtim",
        title15: "E miratuar me sukses",
        title16: "E refuzuar",
        title17: "Pagesa e kryer",
        title18: "Ju lutemi shkruani ose ngjisni adresën e portofolit",
        title19: "Ju lutemi shkruani shumën e tërheqjes",
        title20: "Komisioni",
        title21: "Shuma reale e mbërritur",
        table1: "Monedha",
        table2: "Shuma e tërheqjes",
        table3: "Emri i zinxhirit",
        table4: "Adresa e portofolit",
        table5: "Statusi",
        table6: "Arsyeja",
        table7: "Koha e aplikimit",
        table8: "Tërheqja",
        table81: "Tërheqja",
        table9: "Adresa e tërheqjes",
        table10: "Ju lutemi zgjidhni monedhën që dëshironi të tërhiqni",
        table11: "Ju lutemi sigurohuni që adresa të jetë",
        table12: "Adresë (zakonisht fillon me '0x')",
        table13: "Shuma e disponueshme për tërheqje (pas zbritjes së komisionit):",
        table14: "Zgjidh monedhën",
        table15: "Keni ndonjë problem? Jepni feedback menjëherë",
        table16: "Bilanci",
        table17: "Detajet e tërheqjes",
        password: "Fjalëkalimi",
        passwordTips: "Ju lutemi shkruani fjalëkalimin",
        passwordAg: "Konfirmo fjalëkalimin",
        passwordAgTips: "Ju lutemi shkruani përsëri fjalëkalimin",
        oldPassword: "Fjalëkalimi i vjetër",
        oldPasswordTips: "Ju lutemi shkruani fjalëkalimin e vjetër",
        newPassword: "Fjalëkalimi i ri",
        newPasswordTips: "Ju lutemi shkruani fjalëkalimin e ri",
        passwordNotSame: "Fjalëkalimet nuk përputhen",
        withdrawPasswordSet: "Vendos fjalëkalimin e tërheqjes",
        withdrawPasswordModify: "Ndrysho fjalëkalimin e tërheqjes",
        withdrawPassword: "Fjalëkalimi i tërheqjes",
        withdrawPasswordTips: "Ju lutemi shkruani fjalëkalimin e tërheqjes",
        setWithdrawPasswordFirst: "Ju lutemi vendosni fillimisht fjalëkalimin e tërheqjes",
        withdrawPasswordSetSuccess: "Vendosja ishte e suksesshme",
        withdrawPasswordModifySuccess: "Ndryshimi ishte i suksesshëm",
        submit: "Dërgo",
    },
    customer: {
        content1: "Shërbimi ndaj klientit online",
        content2: "Shërbimi ndaj klientit",
        content3: "Ju lutemi shkruani informacionin tuaj të kontaktit",
        content4: "Ju lutemi shkruani përmbajtjen",
        content5: "Dërgo",
        content6: "Dërgimi dështoi, lidhja e rrjetit dështoi",
        content7: "Imazh",
        content8: "Mesazhi është bosh",
        content9: "Shpërndarja ime",
        content10: "Lidhja e shpërndarjes",
        content11: "Ruaj imazhin",
        content12: "Fitimet e mia",
        content13: "Shpjegimi i niveleve",
        content14: "Numri i ekipit",
        content15: "Fitimet nga ftesat",
        content16: "Shpjegimi i rregullave",
        content17: "Niveli i anëtarësimit",
        content18: "Shuma e depozitimit më e madhe se",
        content19: "Niveli i ekipit",
        content20: "Niveli i ekipit & fitimet",
        content21: "Kushtet e përmbushura",
        content22: "Fitimet nga shpërndarja",
        content23: "Niveli i ekipit",
        content24: "Niveli, ftoni",
        content25: "anëtarë aktivë",
        content26: "Fitimi i nivelit të parë",
        content27: "Fitimi i nivelit të dytë",
        content28: "Fitimi i nivelit të tretë",
    },
    standardContract: {
        increaseMargin: "Rrit margjinën",
        increaseAmount: "Shuma e shtuar",
        Pleaseenterthemargin: "Ju lutemi shkruani shumën e margjinës për të shtuar",
        Pleaseenterthecorrect: "Ju lutemi shkruani shumën e saktë të margjinës",
        Increasemarginsuccessfully: "Shtimi i margjinës ishte i suksesshëm",
        takeProfitPriceWrong: "Çmimi i fitimit është i pasaktë",
        stoppriceerror: "Çmimi i stop-humbjes është i pasaktë",
        thetakeprofit1: "Çmimi i fitimit duhet të jetë më i lartë se çmimi i tregut",
        thetakeprofit2: "Çmimi i stop-humbjes duhet të jetë më i ulët se çmimi i tregut",
        thetakeprofit3: "Çmimi i fitimit duhet të jetë më i ulët se çmimi i tregut",
        thetakeprofit4: "Çmimi i stop-humbjes duhet të jetë më i lartë se çmimi i tregut",
        thetakeprofit5: "Gabim në sasi",
        estimatedprofitloss: "Fitimi/Humbja e pritur",
        positionAmount: "Sasia e pozicionit",
        closeAmount: "Sasia e mbylljes",
        whenthelatest: "Kur çmimi më i fundit arrin",
        whenthelatest2: "do të aktivizohet një porosi me çmim tregu për të mbyllur pozicionin për fitim. Fitimi/Humbja e pritur",
        whenthelatest3: "do të aktivizohet një porosi me çmim tregu për të mbyllur pozicionin për humbje. Fitimi/Humbja e pritur",
        contract: "Kontrata",
        ordercanceledsuccessfully: "Porosia u anulua me sukses",
        successfullyordered: "Porosia u krye me sukses",
        positionopeningreminder: "Kujtesë për hapjen e pozicionit",
        wrongquantity: "Sasia është e pasaktë",
        quantitycannot: "Sasia nuk mund të jetë më e madhe se",
        modificationstoploss: "Ndryshimi i stop-fitimit/stop-humbjes u krye me sukses",
        positionclosedsuccessfully: "Pozicioni u mbyll me sukses",
        orderCancellation: "Anulimi i porosisë",
        orderCancellation2: "Jeni i sigurt që dëshironi të anuloni porosinë?",
        tobeexecuted: "Në pritje për ekzekutim",
        expired: "Ka skaduar",
        failed: "Dështoi",
        contractTransaction: "Kontratë e përhershme",
        increase: "Rritje %",
        openPosition: "Pozicion i plotë",
        isolatedPosition: "Pozicion i izoluar",
        limitOrder: "Porosi me limit",
        marketOrder: "Porosi me çmim tregu",
        pleaseSelectLeverage: "Ju lutemi zgjidhni levën",
        pleaseEnterQuantity: "Ju lutemi shkruani sasinë",
        canOpenMore: "Pozicioni maksimal i hapur",
        contractAmount: "Shuma e kontratës",
        openingFee: "Komisioni i hapjes",
        currentPosition: "Pozicioni aktual",
        historicalPositions: "Transaksionet historike",
        currentCommission: "Porositë aktuale",
        historicalCommission: "Porositë historike",
        buyPrice: "Çmimi i blerjes",
        income: "Fitimi",
        quantity: "Sasia",
        marginRate: "Norma e margjinës",
        initialMargin: "Margjina fillestare",
        estimatedPriceParity: "Çmimi i likuidimit",
        operate: "Operacioni",
        finishQuantity: "Sasia e realizuar",
        averagePrice: "Çmimi mesatar",
        pleaseEnterLeverage: "Ju lutemi shkruani levën",
        takeProfitAndStopLoss: "TP/SL",
        takeProfit: "TP",
        stopLoss: "SL",
        openLong: "Long",
        openShort: "Short",
        liquidation: "Likuidimi",
        marketLquidation: "Likuidim i plotë me çmim tregu",
        cancel: "Anulo",
        enterBuyPrice: "Ju lutemi shkruani çmimin e blerjes",
        areYouSureLquidation: "Jeni i sigurt që dëshironi të mbyllni pozicionin?",
        confirm: "Konfirmo",
        enterStopWinPrice: "Ju lutemi shkruani çmimin e fitimit",
        enterStopLossPrice: "Ju lutemi shkruani çmimin e stop-humbjes",
        commissionTime: "Koha e porosisë",
        commissionPrice: "Çmimi i porosisë",
        commissionQuantity: "Sasia totale e porosisë",
        volumeAlreadyTraded: "Sasia e realizuar",
        areYouSureToWinOrLoss: "Jeni i sigurt që dëshironi të vendosni stop-fitimin/stop-humbjen?",
        maxQuantity: "Kapaciteti maksimal i pozicionit",
        saleQuantity: "Sasia e mbyllur",
        salePrice: "Çmimi mesatar i mbylljes",
        saleTime: "Koha",
        succeeded: "E suksesshme",
        cancelled: "E anuluar",
        piece: "Kontratë",
        triggerPrice: "Çmimi i aktivizimit",
        setWin: "Vendos stop-fitimin",
        setLoss: "Vendos stop-humbjen",
        enterWinQuantity: "Ju lutemi shkruani sasinë për stop-fitim",
        enterLossQuantity: "Ju lutemi shkruani sasinë për stop-humbje",
        planCommission: "Porosi e planifikuar",
        enterWinTriggerPrice: "Ju lutemi shkruani çmimin e aktivizimit për stop-fitim",
        enterLossTriggerPrice: "Ju lutemi shkruani çmimin e aktivizimit për stop-humbje",
        insufficientQuantity: "Sasia është e pamjaftueshme",
        enterTriggerPrice: "Ju lutemi shkruani çmimin e aktivizimit",
        tips1: "Çmimi i porosisë tuaj është më i lartë se çmimi aktual, do të realizohet me çmim tregu. A jeni i sigurt që dëshironi të blini?",
        tips2: "Çmimi i porosisë tuaj është më i ulët se çmimi aktual, do të realizohet me çmim tregu. A jeni i sigurt që dëshironi të blini?",
        type: "Lloji",
        increaseQuantity: "Rrit pozicionin",
        reduceQuantity: "Zvogëlo pozicionin",
        limitCommission: "Porosi me limit",
        tips3: "Çmimi i stop-humbjes duhet të jetë më i ulët se çmimi i tregut",
        tips4: "Çmimi i stop-fitimit duhet të jetë më i lartë se çmimi i tregut",
        tips5: "Çmimi i stop-humbjes duhet të jetë më i lartë se çmimi i tregut",
        tips6: "Çmimi i stop-fitimit duhet të jetë më i ulët se çmimi i tregut",
        tips7: "Çmimi i stop-humbjes duhet të jetë më i vogël se çmimi i tregut dhe më i vogël se çmimi i porosisë",
        tips8: "Çmimi i stop-fitimit duhet të jetë më i madh se çmimi i porosisë (mund të jetë më i vogël se çmimi i tregut)",
        tips9: "Çmimi i stop-humbjes duhet të jetë më i madh se çmimi i tregut dhe më i madh se çmimi i porosisë",
        tips10: "Çmimi i stop-fitimit duhet të jetë më i vogël se çmimi i porosisë (mund të jetë më i madh se çmimi i tregut)",
        accountEquity: "Bilanci i llogarisë",
        unrealizedPL: "Fitim/Humbje e parealizuar",
        tips11: "Jeni i sigurt për",
        tips12: "të kryhet me çmim tregu",
        tips13: "Likuidim i plotë i pozicioneve",
        tips14: "Mos e shfaq më këtë kujtesë",
        profitRate: "Norma e fitimit nga mbyllja",
        openTime: "Koha e hapjes",
        unwindTime: "Koha e mbylljes",
        dealTime: "Koha e transaksionit",
        amountClose: "Shuma e mbyllur",
        long: "Long",
        short: "Short",
        orderQuantity: "Sasia e porosisë",
        entrustedMargin: "Margjina e porosisë",
    },
    spotGoods: {
        spotGoods: "Shkëmbim i shpejtë",
        sellPrice: "Çmimi i shitjes",
        orderRecord: "Regjistri i shkëmbimeve të shpejta",
        transactionTime: "Koha e transaksionit",
        maxBuy: "Maksimumi për blerje",
        maxSell: "Maksimumi për shitje",
        purchaseQuantity: "Sasia e blerjes",
        slippage: "Devijimi i çmimit",
        convertTips: "Ne do ta kryejmë me çmimin më të mirë, devijimi i çmimit është 0-5%.",
        changePrice: "Çmimi aktual i shkëmbimit",
        consume: "Shpenzo",
        consumeAmount: "Sasia e shpenzuar",
        get: "Merr",
        getAmount: "Sasia e marrë",
        changeTips: "A jeni i sigurt që dëshironi të shkëmbeni?",
        confirm: "Konfirmo shkëmbimin"
    },
    news: {
        title: "Qendra e lajmeve",
        redMore: "Lexo më shumë",
    },
    credit: {
        credit: "Pikët e kreditit",
        creditScore: "Totali i pikëve të kreditit",
        latestEntry: "Regjistri më i fundit",
        liveUpdate: "Përditësim në kohë reale",
        systemEvaluation: "Vlerësimi i sistemit",
        time: "Data",
        name: "Emri",
        reason: "Arsyeja",
        scoreStory: "Regjistri i pikëve të kreditit"
    },
    borrowing: {
        borrowing: "Huamarrje",
        diversifiedMarket: "Treg i larmishëm",
        totalSupply: "Shuma totale e furnizimit",
        totalBorrowings: "Shuma totale e huasë",
        tips1: "Kjo është shuma maksimale që mund të merrni hua, në bazë të kolateralit tuaj, deri në kufirin e huasë.",
        tips2: "Gjatë periudhës së huasë, norma e qëndrueshme e interesit do të mbetet e pandryshuar. Rekomandohet për furnizime afatgjata dhe për përdoruesit që preferojnë parashikueshmërinë.",
        totalSupplys: "Totali i furnizimit",
        supplyAPR: "Norma e furnizimit",
        totalBorrowings: "Shuma e huasë",
        borrowAPR: "Norma e huamarrjes",
        check: "Shiko",
        market: "Tregu",
        availableLiquidity: "Likuiditet i disponueshëm",
        currencyPrice: "Çmimi aktual i monedhës",
        supplyAssets: "Asetet e furnizimit",
        tips3: "Shënim: Normat më poshtë janë fikse. Pas përfundimit të ciklit të furnizimit, kapitali plus fitimi do të kthehen në llogarinë tuaj.",
        supplyCycle: "Cikli i furnizimit",
        minimumSupply: "Furnizimi minimal",
        supply: "Furnizo",
        borrowedAssets: "Asetet e marra hua",
        tips4: "Shënim: Për të marrë hua, duhet të siguroni ndonjë aset kolateral ose dëshmi,",
        tips5: "Ju lutemi shikoni shpjegimin e aseteve kolaterale.",
        repaymentCycle: "Cikli i shlyerjes",
        BorrowableAmount: "Shuma e disponueshme për huamarrje",
        borrow: "Merr hua",
        accountInformation: "Informacioni i llogarisë",
        walletBalance: "Bilanci i portofolit",
        canSupply: "Mund të furnizohet",
        AmountCanBeBorrowed: "Shuma totale që mund të merret hua",
        borrowedAmount: "Shuma e marrë hua",
        remainingAmount: "Shuma e mbetur",
        getBorrowednAmount: "Merr shumën e huasë",
        supplyOrder: "Porosi e furnizimit",
        borrowedOrder: "Porosi e huasë",
        supplyAmount: "Shuma e furnizimit",
        expectedProfits: "Fitimet e pritura",
        supplyTime: "Koha e furnizimit",
        expirationTime: "Koha e skadimit",
        borrowingAmount: "Shuma e huasë",
        dueRepayment: "Shuma e shlyerjes",
        borrowingTime: "Koha e dhënies së huasë",
        repaymentTime: "Koha e shlyerjes",
        repay: "Shlyej",
        supplyCurrency: "Monedha e furnizimit",
        buyNow: "Bli tani",
        supplyRecords: "Regjistrat e furnizimit",
        borrowRecords: "Regjistrat e huasë",
        completed: "Përfunduar",
        borrowNow: "Merr hua tani",
        borrowCurrency: "Monedha e huasë",
        borrowMin: "Minimumi",
        borrowMax: "Maksimumi",
        borrowRange: "Shuma e huasë (minimumi/maksimumi)",
        tips6: "Ju lutemi shlyeni në kohë, nëse vonoheni, çdo ditë do të tarifohet shtesë nga shuma (kapitali + interesi)",
        tips7: "si tarifë vonese.",
        pleaseEnterBorrowAmount: "Ju lutemi shkruani shumën e huasë",
        interest: "Interesi",
        tips8: "A jeni i sigurt që doni të shlyeni paraprakisht?",
        borrowChannel: "Kanal huamarrjeje",
        tips9: "Le të fillojmë duke ju njohur",
        name: "Emri",
        lastName: "Mbiemri",
        birthDate: "Data e lindjes",
        tips10: "Na jepni edhe pak informacion, cili është adresa juaj?",
        familyAddress: "Adresa e banesës (përfshirë numrin e njësisë)",
        city: "Qyteti",
        country: "Shteti",
        postalCode: "Kodi postar",
        pleaseEnterYourHomeAddress: "Ju lutemi shkruani adresën e banesës tuaj",
        tips11: "Na tregoni gjendjen tuaj financiare",
        tips12: "Mund të na duhet ta verifikojmë këtë informacion më vonë, ndaj ju lutemi jepni sa më saktë",
        yourMonthlyIncome: "Të ardhurat tuaja mujore",
        enterYourMonthlyIncome: "Ju lutemi shkruani të ardhurat tuaja mujore",
        extraIncomeOptional: "Të ardhura shtesë (opsionale)",
        enterExtraIncome: "Ju lutemi shkruani të ardhurat tuaja shtesë",
        monthlyRentOrMortgagePayment: "Qiraja mujore ose pagesa e kredisë hipotekare",
        enterMonthlyRent: "Ju lutemi shkruani qiranë mujore ose pagesën e hipotekës",
        tip13: "Na tregoni nëse keni kolateral",
        tip14: "Nëse nuk zgjidhni garanci kolaterale, probabiliteti i miratimit është më i ulët",
        isThereMortgage: "A ka kolateral",
        selectIsThereMortgage: "Ju lutemi zgjidhni nëse ka kolateral",
        selectMortgageType: "Ju lutemi zgjidhni llojin e kolateralit",
        yes: "Po",
        no: "Jo",
        uploadScreenshotOfTransaction: "Ju lutemi ngarkoni pamjen e transaksionit",
        tip15: "Le të qëndrojmë në kontakt",
        tip16: "Nëse kemi nevojë për më shumë informacion mbi aplikimin tuaj për hua, mund t'ju kontaktojmë në këtë numër",
        tip17: "E kam lexuar dhe pajtohem me nënshkrim elektronik",
        tip18: "Kushtet e përdorimit dhe Marrëveshja elektronike e pranimit",
        tip19: ", duke përfshirë pranimin tuaj që të ju dërgojmë informacione në lidhje me",
        tip20: "kushtet e përdorimit të produkteve dhe shërbimeve",
        tip21: "Pasi të keni plotësuar të gjitha të dhënat, ju lutemi prisni vlerësimin dhe shqyrtimin e sistemit.",
        phoneNumber: "Numri i telefonit",
        enterPhoneNumber: "Ju lutemi shkruani numrin tuaj të telefonit",
        tip22: "Ju lutemi shënoni kutinë për të pranuar Kushtet e përdorimit dhe Marrëveshjen elektronike të pranimit",
        inReview: "Në shqyrtim",
        applicationAmount: "Shuma e aplikimit",
        reasonForRejection: "Arsyeja e refuzimit",
        reapply: "Aplikoni përsëri",
        applyStatus: "Statusi i aplikimit",
        currentOrder: "Porosia aktuale",
        interestRate: "Norma e interesit"
    },
    yuebao: {
        filed1: "Investim",
        filed2: "Tërheqje",
        filed3: "Fitimi ditor",
        filed4: "Përshpejtimi i ekipit",
        filed5: "Depozituar",
        filed6: "Fitimi i djeshëm",
        filed7: "Fitimi total",
        filed8: "Fonde të disponueshme",
        filed9: "Ju lutemi shkruani shumën",
        filed10: "Miniera e likuiditetit",
        filed11: "Përshkrim",
        field12: "Blerja minimale",
        field13: "Blerja maksimale",
        filed14: "Abonohu",
        filed15: "Afat i caktuar",
        filed16: "Norma vjetore e interesit",
    },
    tipsPopover: {
        title: "Instalo këtë aplikacion",
        press: "Shtyp",
        and: "dhe",
        scrren: "Shto në ekranin kryesor",
        hasInstall: "(Nëse është instaluar tashmë, ju lutemi mbyllni dritaren)",
    },
    follow: {
        title1: "Plani i ndjekjes së tregtimit",
        follow_text1: "Nis ndjekjen",
        follow_text2: "Historia e publikimeve",
        follow_text3: "Titulli",
        follow_text4: "Çifti tregtar",
        follow_text5: "Kohëzgjatja e blerjes",
        follow_text6: "Koha e porosisë",
        follow_text7: "Koha e publikimit",
        follow_text8: "Numri i ndjekësve",
        follow_text9: "Shuma e ndjekjes",
        follow_text10: "Operacioni",
        follow_text11: "Fto",
        follow_text12: "Drejtimi i ndjekjes",
        follow_text13: "Vendos kushtet e ndjekjes",
        follow_text14: "Kufizimet e kushteve të ndjekjes",
        follow_text15: "Shuma fikse",
        follow_text16: "Përqindja",
        follow_text17: "I ftuari",
        follow_text18: "ID e palës tjetër",
        follow_text19: "Konfirmo ndjekjen",
        follow_text20: "Shuma e ndjekjes suaj (opsionale)",
        follow_text21: "Ju lutemi shkruani titullin",
        follow_text22: "Ju lutemi zgjidhni çiftin tregtar",
        follow_text23: "Ju lutemi zgjidhni drejtimin e ndjekjes",
        follow_text24: "Ju lutemi zgjidhni kohëzgjatjen e blerjes",
        follow_text25: "Ju lutemi zgjidhni kohën e porosisë",
        follow_text26: "Ju lutemi zgjidhni sasinë e blerjes",
        follow_text27: "Sasia maksimale e blerjes nuk mund të jetë më e vogël se ajo minimale",
        follow_text28: "Blerja minimale",
        follow_text29: "Blerja maksimale",
        follow_text30: "Krijimi i ndjekjes u krye me sukses",
        follow_text31: "Lista e çifteve tregtare",
        follow_text32: "E ndjekur",
        follow_text33: "Ju lutemi shkruani informacionin e të ftuarit",
        follow_text34: "E ftuar",
        follow_text35: "Më kanë ftuar",
        follow_text36: "Historia e ndjekjes",
        follow_text37: "Shtrirja e shumës së ndjekjes",
        follow_text38: "Ju lutemi shkruani kodin e ndjekjes",
    },
    followHistory: {
        title1: "Historia e publikimeve",
        title2: "Historia e ndjekjes",
        follow_h_text1: "Shuma totale e ndjekjes",
        follow_h_text2: "Numri total i ndjekësve",
        follow_h_text3: "Numri i publikimeve",
        follow_h_text4: "Shkalla e fitoreve",
        follow_h_text5: "Numri i ndjekjeve",
        follow_h_text6: "Fitimi nga ndjekja",
        follow_h_text7: "Drejtimi",
        follow_h_text8: "Fitim",
        follow_h_text9: "Humbje",
    },
    "asset.index.1579E8B41F8D5134": "Pasuritë e mia",
    "asset.index.B3F6F05Dfbe431Cd": "Simulim",
    "asset.index.B9Aeab4Ee8F33746": "Vlerësimi i pasurisë",
    "asset.index.583Df8Bd541Eb7E8": "Tendenca e fitimit",
    "asset.index.B1254815D133Cc26": "7 ditë",
    "asset.index.2F615F6C029F01B7": "30 ditë",
    "asset.index.29439Fb58E4Bbe22": "Tërheqje",
    "asset.index.831Ab31568A78285": "Depozitë",
    "asset.index.39F7A0D48D12E8C9": "Transferim",
    "asset.index.B99063C5689Beaec": "Shkëmbim i menjëhershëm",
    "asset.index.E1Dc620F2F038B2A": "Merr pasuri",
    "asset.index.972A0B4C2B4393D0": "Llogaria ime",
    "asset.index.9Dfb0Fb334620733": "Bilanci i disponueshëm",
    "asset.index.Cdc5Fbd26790Cb47": "Shuma e ngrirë",
    "asset.index.3D8132D72Ae965Cd": "Vlerësim",
    "asset.receive.825503Cc430559Cb": "Merr pasuri",
    "asset.receive.54154A0553A535B7": "Pasuri demonstrative",
    "asset.receive.F2E57B00A9C5D129": "1. Kjo pasuri lejohet vetëm në modalitetin e llogarisë së simuluar",
    "asset.receive.Ea0D1D52989299Bd": "2. Për të shmangur abuzimin, lejohet vetëm një herë marrje brenda një muaji",
    "asset.receive.090E0037Aa235D3D": "3. Pasuria e marrë do të shtohet mbi bazën ekzistuese pa ndryshuar gjendjen e pozicionit",
    "asset.receive.7Fd4E1Abc805C0A6": "4. Nëse keni pyetje të tjera, ju lutemi kontaktoni shërbimin ndaj klientit",
    "asset.receive.Df5B3A511D986575": "Merr menjëherë pasuri demonstrative",
    "asset.records.1Fa02E8187A39592": "Tre muajt e fundit",
    "asset.records.7B291C37333Fe34D": "Nga më i riu tek më i vjetri",
    "asset.records.A476Cd1Ec868Fc5F": "Tre muajt e fundit,",
    "asset.records.9D5755A842E55Bb7": "Nga më i riu tek më i vjetri,",
    "asset.records.E3Fa05E607203Cdc": "Depozitë",
    "asset.records.B4F206C6Bec08Dea": "Tërheqje",
    "asset.index.Df5B3A511D986576": "Ju keni marrë me sukses pasuri demonstrative",
    "deposit.depositSpeedy.Efe81D0E0174239B": "Mënyra e pagesës",
    "deposit.depositSpeedy.B9293Ee96E435F85": "Monedha fiat",
    "deposit.depositSpeedy.16658A855F07D171": "Shuma",
    "deposit.depositSpeedy.204Ffab8A6E01870": "Konfirmo",
    "deposit.depositSpeedy.22E5Dfb74Ead8Aa9": "Nuk mund të jetë bosh",
    "deposit.depositSpeedy.B8E774D0E4E5E4C1": "Depozita minimale",
    "deposit.depositSpeedy.F169D816F6Dd83C5": "Depozita maksimale",
    "deposit.depositWallet.F64Ec60B1Db4A6D6": "Depozitë USDT",
    "deposit.depositWallet.551640C76F4Ca4A1": "Monedha e depozitës",
    "deposit.depositWallet.B404C543712B71D5": "Rrjeti i depozitës",
    "deposit.depositWallet.A484B0F5E94B3F4F": "Adresa e depozitës",
    "deposit.depositWallet.D3980D54Acf242Db": "Ruaj kodin QR",
    "deposit.depositWallet.A06E84801D6582Be": "Shuma e depozitës",
    "deposit.depositWallet.Daaaeb1B7B22B126": "Këshillë",
    "deposit.depositWallet.D599E40E1Eeec1B3": "Depozita e suksesshme",
    "deposit.depositWallet.4F48Abbafce532Bb": "Dorëzimi me sukses, pritni verifikimin nga shërbimi ndaj klientit",
    "deposit.depositWallet.A88C481228811696": "Ju refuzuat të ndryshoni rrjetin",
    "deposit.depositWallet.C6Ebf27895C21932": "Ju lutemi hapni manualisht shtojcën e portofolit TRON dhe hyni",
    "deposit.index.B5491C8Dd09D8183": "Zgjidhni monedhën që doni të depozitoni",
    "deposit.index.2F784B2298D39987": "Depozitë e shpejtë",
    "deposit.index.0Daa03Dcdcabd837": "Lidhje jashtë platformës",
    "withdraw.bottomSheet.628A63056Ef2D2Fe": "Konfirmimi i tërheqjes",
    "withdraw.bottomSheet.A086Fa20082C849D": "Sigurohuni që informacioni i dhënë më poshtë është i saktë",
    "withdraw.bottomSheet.Bf8B184D32971501": "Rrjeti i tërheqjes",
    "withdraw.bottomSheet.8758Fd50C87D6C9C": "Adresa",
    "withdraw.bottomSheet.F9Db93B87E08763B": "Shuma",
    "withdraw.bottomSheet.4Ad26475002878C0": "Komisioni",
    "withdraw.index.A96454041169Af6D": "Zgjidh monedhën",
    "withdraw.index.2A563B7081Dd5B83": "Adresa e tërheqjes",
    "withdraw.index.B189C2Ef713Cfff4": "Shuma e tërheqjes",
    "withdraw.index.558F35140E84B562": "E disponueshme:",
    "withdraw.index.F4E759087E12Cb77": "Tërhiq gjithçka",
    "withdraw.index.5Cbd9A6B284D25Ae": "Fjalëkalimi i fondeve",
    "withdraw.index.B89Cbe4Bfc33Bb41": "Komisioni:",
    "withdraw.index.C886De8D8A27026E": "Njoftim i rëndësishëm",
    "withdraw.index.Eac7C5A4095F5606": "1. Për të parandaluar veprimet e arkëtimit, mund të aplikoni për tërheqje vetëm pasi volumi i tregtisë të arrijë shumën e caktuar.",
    "withdraw.index.C3Cc7Fff24504Be9": "2. Pasi të dorëzohet kërkesa për tërheqje, fondet do të mbërrijnë brenda 24 orëve; nëse jo, kontaktoni shërbimin online.",
    "withdraw.index.0B4Ad7Ccdc833B0D": "3. Pas dorëzimit, fondet hyjnë në gjendje të ngrirë deri sa të përfundojë procesi i tërheqjes; kjo nuk nënkupton humbje të fondeve.",
    "withdraw.index.4639F3A6E07C00B3": "Hapi tjetër",
    "withdraw.index.81Fba0D65Cc5C3Aa": "Ju lutemi shkruani ose ngjitni adresën e portofolit",
    "withdraw.index.25768141C8Bdea91": "Ju lutemi shkruani shumën e tërheqjes",
    "withdraw.index.97A85734Cd1B7Bf0": "Ju lutemi shkruani fjalëkalimin e fondeve",
    "withdraw.index.39C7D74B33241C78": "Shuma e tërheqjes është e pasaktë",
    "withdraw.index.86A5D17908197525": "Konfirmimi i tërheqjes, në pritje të verifikimit",
    "withdraw.index.48Fb603C6638C7F6": "Ju lutemi caktoni fjalëkalimin e fondeve",
    "withdraw.index.873Ade9A3Bacc2F7": "Këshillë",
    "bill.index.5Bbb2A6Ac68D6B2E": "Llogari reale",
    "bill.index.75751E0Eb8261C40": "Llogari e simuluar",
    "bill.index.Cbc853B37Ecc2E97": "Lloji i ndryshimit të llogarisë",
    "bill.index.4A0Cacddeb2E38B1": "Lloji i llogarisë",
    "bill.index.F16217028E098B2F": "Monedha",
    "bill.index.A620Dbe6F06B78Ba": "Të gjitha llojet",
    "bill.index.2C3C148Bb94D9B3F": "Të gjitha llogaritë",
    "c2C.index.Ab45695E4Bf1E382": "Tregtia C2C",
    "c2C.index.2702Dc911Dfea762": "Dua të blej",
    "c2C.index.D737D5B8367A53C4": "Dua të shes",
    "c2C.index.C0C540A3Ba9Abe01": "Vëllimi i tregtisë",
    "c2C.index.D8644E8D60C8Bd8A": "Çmimi për njësi",
    "c2C.index.Ebb8670B203D3604": "Kufiri",
    "c2C.index.F8C6245A2Ebf1D27": "Të gjitha kartat bankare",
    "c2C.index.F8C6245A2Ebf1D28": "Marrje me kripto",
    "c2C.index.F8C6245A2Ebf1D29": "Karta bankare",
    "c2C.index.Cc3Aa8141Da9Ec9E": "Bli",
    "c2C.index.Cc3Aa8141Da9Ec9F": "Shit",
    "c2C.index.67A39834582Ad99A": "Nuk ka të dhëna",
    "c2C.order.04C23810B47F77F7": "Sipas shumës",
    "c2C.order.6905365902E0A73D": "Sipas sasisë",
    "c2C.order.3F0Ecebbd9D2F23B": "E disponueshme",
    "c2C.order.16853Bda54120Bf1": "Të gjitha",
    "c2C.order.Ad3335796F2C95F7": "Shuma totale",
    "c2C.order.61092E27A6879318": "Për të mbrojtur pasurinë, rrisni ndërgjegjësimin tuaj!",
    "c2C.order.0F51881F0Fb920B2": "Informacioni i tregtisë",
    "c2C.order.Dd74Ceca85E5Bc65": "Afati i pagesës",
    "c2C.order.De3341388A59073F": "30 minuta",
    "c2C.order.D334B597A352167F": "Pseudonimi i shitësit",
    "c2C.order.D334B597A352167G": "Pseudonimi i blerësit",
    "c2C.order.9D5F89F99Ced890D": "Mënyra e tregtisë",
    "c2C.order.8Adf755B14Bc6B7C": "Ju lutemi lexoni së pari përmbajtjen e mëposhtme",
    "c2C.order.686B16F454A7338B": "Mos vendosni shënime gjatë transferimit bankar, përndryshe nuk do të lirohen fondet dhe llogaria do të bllokohet. Pas pagesës duhet të ofroni një imazh të ri të detajeve të transaksionit (nëse imazhi është i manipuluar ose i fshehur, llogaria do të ngrijë).",
    "c2C.order.9Bec8Fba867B739B": "Zgjidhni mënyrën e pagesës",
    "c2C.order.Cf2D892C419Fea36": "Blerja minimale",
    "c2C.order.7290A6B7456A03E0": "Blerja maksimale",
    "c2C.orderConfirm.F7E99B8C203E2B07": "Detajet e porosisë",
    "c2C.orderConfirm.036D94Dc2D1Cf7D3": "Porosia u krijua",
    "c2C.orderConfirm.0F5433503F3845Ce": "Ju lutemi paguani shitësin brenda kohës së numërimit mbrapsht.",
    "c2C.orderConfirm.24C3Bcacdb85A451": " Në pritje të pagesës nga blerësi ",
    "c2C.orderConfirm.8E8140D7Ab607B24": "Kontakto shitësin",
    "c2C.orderConfirm.8E8140D7Ab607B25": "Kontakto blerësin",
    "c2C.orderConfirm.Ec4D8722Ec15C813": "Kriptomonedha e shitësit është depozituar në llogarinë e ruajtjes, mund të paguani me siguri",
    "c2C.orderConfirm.69D1Fbbc7700C1Ab": "Emri real i blerësit:",
    "c2C.orderConfirm.E5Ed8Ec53Edcd5D3": "Mbështetje 24/7 ndaj klientit",
    "c2C.orderConfirm.Abf9F4B8C93D641E": "Numri i porosisë",
    "c2C.orderConfirm.726C51702F70C486": "Koha e krijimit",
    "c2C.orderConfirm.E097Bb9B1216Bfd8": "Kontakto shërbimin ndaj klientit",
    "c2C.orderConfirm.103408Fbbe30287F": "Anulo porosinë",
    "c2C.orderConfirm.4E93Df1Fb521F4Ba": "Kam konfirmuar pagesën",
    "c2C.orderConfirm.3B5418Dbea7Ebfe4": "Pagesa e kryer",
    "c2C.orderConfirm.387Ca3625B260E4E": "Porosia juaj është paguar",
    "c2C.orderConfirm.7C83D5F1Db1A08B7": "Tregtia u anulua",
    "c2C.orderConfirm.76C86566Cc3751C0": "Porosia u anulua",
    "c2C.orderConfirm.205B349751D176B4": "Pagesa e suksesshme",
    "c2C.paymentAdd.6F2A7Dcc66E6Acba": "Mënyra e marrjes së pagesës",
    "c2C.paymentAdd.C87E865Df6800304": "Konfigurimi i mënyrës së pagesës",
    "c2C.paymentAdd.B59Ae0F1B1C235Df": "Lloji i mënyrës së pagesës",
    "c2C.paymentAdd.06910Bddf002695F": "Emri i vërtetë",
    "c2C.paymentAdd.3E33Ae3Efa7507Dd": "Llogaria PayPal",
    "c2C.paymentAdd.3E33Ae3Efa7507De": "Llogaria / numri i kartës bankare",
    "c2C.paymentAdd.3E33Ae3Efa7507Df": "Emri i monedhës",
    "c2C.paymentAdd.595Ede91Abf6F6E0": "Kodi QR i pagesës",
    "c2C.paymentAdd.1Ecc8Be9Ba1C940A": "Kliko për të ngarkuar",
    "c2C.paymentAdd.6Daae340F2E9718A": "Emri i bankës",
    "c2C.paymentAdd.347751415C3Da489": "Emri i zinxhirit",
    "c2C.paymentAdd.15B3627Faddccb1D": "Shënim",
    "c2C.paymentAdd.86Da96Cbd274058F": "Këshillë miqësore: Kur shisni kriptomonedhë, mënyra e pagesës që zgjidhni do t’i shfaqet blerësit, ju lutemi sigurohuni që informacioni është i saktë.",
    "c2C.paymentAdd.4Ce9979Bfb6576D9": "Ruaj",
    "c2C.paymentAdd.90D2A3A5C07179C0": "Ju lutemi shkruani emrin tuaj të vërtetë",
    "c2C.paymentAdd.A3B0Cd3Ad9Ca3475": "Ju lutemi shkruani tuajin",
    "c2C.paymentAdd.Ec389E6190Eedb62": "Ju lutemi shkruani emrin e bankës tuaj",
    "c2C.paymentAdd.9Be51Fb1E9025Fb2": "Ju lutemi shkruani emrin e zinxhirit tuaj",
    "c2C.paymentAdd.94F034F0E01439E0": "Ju lutemi shkruani adresën tuaj",
    "c2C.paymentAdd.B12E035663A42B32": "Të gjitha kartat bankare",
    "c2C.paymentAdd.C7B677F393A8F8Ac": "Pagesë me kripto",
    "c2C.paymentAdd.Abafe11737Bab7Cd": "Ju lutemi ngarkoni kodin e pagesës",
    "c2C.paymentAdd.07C443212Ff04Bfb": "Shtuar me sukses",
    "c2C.paymentDetail.86Da96Cbd274058F": "Këshillë miqësore: Kur shisni kriptomonedhë, mënyra e pagesës që zgjidhni do t’i shfaqet blerësit, ju lutemi sigurohuni që informacioni është i saktë.",
    "c2C.paymentDetail.C4C613Da60226De4": "Modifikimi u krye me sukses",
    "c2C.paymentMethod.7609F7C8337C7A17": "Metoda e pagesës C2C",
    "c2C.records.9E36893D5736Abb4": "Lista e porosive",
    "c2C.records.4B53F9A5B13B3235": "Në pritje të pagesës",
    "c2C.records.4B53F9A5B13B3236": "Tregtia e anuluar",
    "c2C.records.4B53F9A5B13B3237": "E paguar",
    "contract.index.9706Df877458F0Be": "Llogaria e plotë",
    "contract.index.623Fc7D3D40Aa479": "Marzhi fillestar",
    "contract.index.F92Dce1169330387": "Likuidim total në treg",
    "contract.index.3598B97Dd28Dbf20": "Ju lutemi shkruani sasinë (kontrata)",
    "contract.index.6E1Fae821Dc0B797": "I përhershëm",
    "contract.index.Eb07Eb0C37C14575": "Dorëzim",
    "contract.index.Eb6492F19B1C1Fb6": "Detajet e transaksioneve historike",
    "contract.index.873Ade9A3Bacc2F7": "Këshillë",
    "contract.index.Ff63B0F93D39F50B": "Jeni të sigurt për",
    "contract.index.Ff63B0F93D39F50D": "Bli gjatë",
    "contract.index.Ff63B0F93D39F50E": "Shit shkurt",
    "contract.index.Ff63B0F93D39F50F": "të kryhet",
    "contract.index.Ff63B0F93D39F50G": "Likuidim total?",
    "customer.dialog.3D410C88E8A24Fe8": "Konfirmo pseudonimin",
    "customer.dialog.4B3340F7872B411F": "Anulo",
    "customer.dialog.549B1456Bb5F98B3": "Ju lutemi shkruani pseudonimin tuaj",
    "customer.dialog.B773B3E45Ccfad00": "Pseudonimi është bosh",
    "customer.index.7308C6B849D159E9": "Detajet e imazhit",
    "delivery.callDialog.C74F562C3Fe91Fe3": "Porosia u krye me sukses",
    "delivery.callDialog.B8C98F42Caa15Ca5": "Drejtimi",
    "delivery.callDialog.B79A581Dae543974": "Bli gjatë",
    "delivery.callDialog.B79A581Dae543975": "Shit shkurt",
    "delivery.callDialog.3B26F0F7E90773F3": "Çmimi i hapjes",
    "delivery.callDialog.65Fb252Bd94E1039": "Fitimi i pritur",
    "delivery.index.B483Ba4Fce633539": "Dorëzim",
    "delivery.index.224Dd6Cb58D58249": "Periudha e tregtisë",
    "delivery.index.28158F517E902788": "Blerja minimale",
    "delivery.index.A1232162B14Bec76": "Porositë e dorëzimit",
    "delivery.index.445B1D3176D9C69D": "Porositë historike",
    "delivery.index.Ab6Cb86E28653C5C": "Dorëzim",
    "delivery.index.20A7A6F14D3698C0": "Koha e hapjes",
    "delivery.index.Ec6821A49395Ddc2": "Koha e mbylljes",
    "delivery.index.254Fdc665C391743": "Çmimi i mbylljes",
    "delivery.index.2A0C5E68B44A472A": "Fitim/Humbje",
    "delivery.index.E05B33309F6D236A": "Ju lutemi shkruani sasinë",
    "delivery.index.B2899E073Cb355D9": "Blerja minimale",
    "download.description.869467A93C7Dd4A1": "Instruksionet e instalimit",
    "download.description.C80C1Edd6Bee12Bc": "1. Lejoni shkarkimin e skedarit të përshkrimit",
    "download.description.2F5Bc180F92642B4": "2. Skedari i përshkrimit është shkarkuar",
    "download.description.3C3B849F6Ccf712F": "3. Shkoni tek [Cilësimet] në telefon, poshtë informacionit të llogarisë do të shfaqet skedari i shkarkuar",
    "download.description.86Affd862985E045": "4. Klikoni skedarin e shkarkuar",
    "download.description.32832492Bfc1D95E": "5. Klikoni Instalo",
    "download.index.245883C80F181C4A": "Shkarko",
    "download.index.Ef3De8Cb2722937A": "Tregtoni kudo, në çdo kohë",
    "download.index.F4A87Eaeed691638": "Me aplikacionin tonë, informohuni gjithmonë me lajmet më të fundit",
    "download.index.Ad3Aba52D0D39D01": "Shkarko paketën e instalimit",
    "download.safariGuide.61Bd9A8Fcc2Ea788": "Këshillë miqësore",
    "download.safariGuide.2Cc68Aaadf623477": "Ju lutemi hapeni në Safari",
    "download.safariGuide.C80Fff2A6Ff4E768": "Ju po vizitoni një faqe të decentralizuar, ju lutemi përdorni aplikacionin Safari",
    "download.safariGuide.06Da016F3E2F79Bd": "Kopjo linkun",
    "finance.index.B034B367545D5236": "Projekte globale cilësore",
    "finance.index.6Ebfac2C0A9228B0": "Mbi 1.6 milion përdorues aktivë, $122.4 miliardë",
    "finance.index.52Bdcaf19659363D": "Minierë likuiditeti",
    "finance.index.D66924272B031Bf5": "Fitime vjetore shumë të larta",
    "finance.index.34789D88Afcefa64": "Shiko projektet",
    "finance.index.E12676B95654D21E": "Kredi me besim",
    "finance.index.4C924Cfd89A11Ac7": "Zbuloni më shumë mundësi tregtare",
    "finance.index.C251D4B594Da2848": "AI Kuantitativ",
    "finance.index.4E53Cf2E5F173Dd3": "Qira me një klik, tregtim inteligjent AI",
    "finance.records.Cce168301447D1Ba": "Në proces",
    "finance.records.4587B6Bd7Cfa4454": "I shlyer",
    "finance.records.18685418E3A50147": "Minierë",
    "finance.records.Df9Fd438F97Cc908": "Ditë",
    "finance.records.E23Cb03C5Ad359E5": "Afati",
    "finance.records.Bd87Dac6Cba7Eba8": "Sasia e blerë",
    "finance.records.2D0Fff99265E8B1A": "Fitim i realizuar",
    "finance.records.2D0Fff99265E8B1B": "Fitim në maturim",
    "finance.records.024F5F0B851782De": "Koha e minierës:",
    "finance.records.3143A26D3F983896": "Koha e shlyerjes:",
    "finance.records.96574Aaf8Db85Ead": "Shlyerje e parakohshme",
    "finance.records.531E1829203181Ac": "A jeni i sigurt që doni të shlyeni më herët?",
    "finance.records.9205843B8923Dac3": "Shlyerje e suksesshme",
    "loan.applyCallback.B9258Ec8746A74D8": "Kanali i kredisë",
    "loan.applyForm.7B8Ed340400A6E2B": "Emri",
    "loan.applyForm.549A44Bae725F4A2": "Mbiemri",
    "loan.applyForm.2A27E61375E7Fea8": "Data e lindjes",
    "loan.applyForm.89925B019D537738": "Adresa e emailit",
    "loan.applyForm.Afaeb32Cb4D62E28": "Adresa e banesës (përfshirë nr. të njësisë)",
    "loan.applyForm.E05B5D049B64B040": "Qyteti",
    "loan.applyForm.B166E4E8Fe9513Fa": "Shteti",
    "loan.applyForm.83Aaede109E395F8": "Kodi postar",
    "loan.applyForm.647Ed21332A4968B": "Të ardhurat tuaja mujore",
    "loan.applyForm.Cf0A9B845D34D4B4": "Të ardhura shtesë (opsionale)",
    "loan.applyForm.7048F618Acc6A54C": "Qira ose kësti mujor i hipotekës",
    "loan.applyForm.15C1Bba18Ae18545": "Na tregoni nëse keni kolateral",
    "loan.applyForm.3921E90625A84E36": "Nëse nuk zgjidhni kolateral, mundësia e aprovimit është më e ulët",
    "loan.applyForm.262Eec4F8906B0F6": "A keni kolateral?",
    "loan.applyForm.8634Eb21B6910F21": "Ju lutemi zgjidhni llojin e kolateralit",
    "loan.applyForm.A4897B3A331B5E61": "Dëshmi transaksioni",
    "loan.applyForm.6623384C683De457": "Le të qëndrojmë në kontakt",
    "loan.applyForm.A8360Bdba86834Cb": "Nëse na duhet më shumë informacion mbi aplikimin tuaj për kredi, mund t’ju kontaktojmë në këtë numër",
    "loan.applyForm.C1C373F385A4C7B3": "Numri i telefonit",
    "loan.applyForm.1B9785Badb91191F": "Pasi të keni plotësuar të dhënat, ju lutemi prisni vlerësimin e sistemit.",
    "loan.applyForm.8755B9C761D4080C": "E kam lexuar dhe pajtohem me nënshkrim elektronik",
    "loan.applyForm.3E987B787468148C": "Kushtet e përdorimit dhe marrëveshja elektronike",
    "loan.applyForm.Bc54E76B61C50Fb9": "Ju lutemi lexoni dhe pranoni marrëveshjen",
    "loan.applyForm.89E158384F634Eb8": "Kthehu një hap pas",
    "loan.applyForm.Efa5A4548E2F3510": "Adresa e banesës",
    "loan.applyForm.4Cadf1787541B35D": "Po,",
    "loan.applyForm.Fab408D2F4100447": "Jo,",
    "loan.applyForm.3Bad7A307480Cc56": "Formati i email-it është i pasaktë;",
    "loan.applyForm.306322F49B36855D": "Aplikimi është dorëzuar, ju lutemi prisni rishikimin nga shërbimi ndaj klientit",
    "loan.applyForm.3C6E0E858C995Ff9": "Ju lutemi ngarkoni dëshminë e transaksionit",
    "loan.applyForm.2Bf443476B271376": "Mund të ngarkohen maksimumi 4 imazhe",
    "loan.applyQuota.Ef1D8E23003B9A6F": "Kanali i kredisë",
    "loan.applyQuota.Ef1D8E23003B9A6G": "Merr kufirin e huasë",
    "loan.applyQuota.9E0780F9352C7273": "Bilanci i portofolit",
    "loan.applyQuota.Cbc1Eb9D639A6105": "Totali i shumës që mund të huazohet",
    "loan.applyQuota.033A05462195B080": "Shuma e marrë hua",
    "loan.applyQuota.9Aa89B036Ef4821D": "Shuma e mbetur",
    "loan.applyQuota.5656Fb52Ef17A557": "Merr kufirin e huasë",
    "loan.applyQuota.6Ff6702B4C917D40": "Në rishikim",
    "loan.applyQuota.6Ff6702B4C917D41": "Refuzuar",
    "loan.applyQuota.6Ff6702B4C917D42": "E suksesshme",
    "loan.applyQuota.0Bad0E857Ea4A952": "Koha e aplikimit",
    "loan.applyQuota.3E7E56E2De2Cc546": "Shuma e aplikimit",
    "loan.applyQuota.8F1D170D9E54Af5B": "Progresi i aplikimit",
    "loan.applyQuota.6167Ca035B93Caf3": "Arsyeja",
    "loan.applyQuota.410C7954F9A3981D": "Apliko përsëri",
    "loan.bottomSheet.61Cd62F861D8F5B2": "Ju lutemi zgjidhni monedhën",
    "loan.index.4C10307B22E885C3": "Zbuloni më shumë mundësi tregtare për të krijuar pasuri",
    "loan.index.Ae8D37Dea2B3717B": "Norma e interesit",
    "loan.index.1Bb54625682E85Db": "Prezantimi i rregullave",
    "loan.index.5Bd31Fab681C6E9D": "Shiko më shumë",
    "loan.index.111F95F404814327": "Monedha e huasë",
    "loan.index.6Bc2723B3Bec106D": "Huazim",
    "loan.index.3200106280E6E370": "Norma e interesit",
    "loan.index.049A6Ccb6C81A635": "Shuma e huasë (minimum/maksimum)",
    "loan.productDetails.5037Ad86Ab4B7E02": "Huazim",
    "loan.productDetails.37181C74559Db182": "Porosia",
    "loan.productDetails.5802Aaf06A1E4755": "Likuiditet i disponueshëm",
    "loan.productDetails.89Aea9Cf9337C40F": "Shuma që mund të merret hua",
    "loan.productDetails.9E419Ae2D06F3Ad9": "Shuma për t’u shlyer",
    "loan.productDetails.C65F329Ef14C4A3D": "Shuma e huazuar",
    "loan.productDetails.3A74667815Adc8Bf": "Maksimale",
    "loan.productDetails.Ab851D8351573227": "Ditë",
    "loan.productDetails.Ddf82D8A2C8F46A0": "Cikli i pagesës",
    "loan.productDetails.C105E5562005Aeb1": "Ditë",
    "loan.productDetails.3F346Be2137F0756": "Shuma e huasë (minimum/maksimum)",
    "loan.productDetails.2707F78Df864E194": "Interesi",
    "loan.productDetails.B9Dc9B81E726Bdf1": "Ju lutemi shlyeni në kohë, nëse vonoheni, çdo ditë do të ngarkohet shtesë nga shuma (kryegj + interes)",
    "loan.productDetails.B9Dc9B81E726Bdf2": "% si tarifë vonese",
    "loan.productDetails.4D94Faa033Be7356": "Unë pajtohem me",
    "loan.productDetails.62429A957A22780A": "Marrëveshjen e shërbimit të huasë",
    "loan.productDetails.Bc54E76B61C50Fb9": "Ju lutemi lexoni dhe pranoni marrëveshjen",
    "loan.productDetails.Ec8Ba071C53A67Cb": "Merr hua tani",
    "loan.productDetails.59246A0Bf081D398": "Minimum",
    "loan.productDetails.Ec3F1172B71Cd36C": "Shuma minimale",
    "loan.productDetails.7Ccc4Cf1D81930B3": "Shuma maksimale",
    "loan.productDetails.071488598990Aa68": "Ju lutemi lexoni dhe pranoni marrëveshjen;",
    "loan.productDetails.579Dd216D3339119": "Huazimi ishte i suksesshëm;",
    "loan.records.4951B36Fd0D2A831": "Regjistrat e huasë",
    "loan.records.Bb0Aaa30514B7Cba": "Regjistrat aktualë",
    "loan.records.0F8B0A7D80769051": "Regjistrat e pagesës",
    "loan.records.D4B42E43D88De6F1": "Regjistrat historikë",
    "loan.records.Cb1847D6281897E6": "Shuma e huazuar",
    "loan.records.C7Bfcacfc2Adea58": "Shuma e shlyerjes",
    "loan.records.8B369164D5Fea340": "Koha e huazimit:",
    "loan.records.Ab2402Ad3Ffd35E7": "Shlyerje e parakohshme",
    "loan.records.B7A0Ca0C195D0Cd1": "Koha e disbursimit:",
    "loan.records.42014Bdcfd9C411B": "Koha e shlyerjes:",
    "loan.records.A0Acfaee54F06458": "E përfunduar",
    "loan.records.67A39834582Ad99A": "Nuk ka të dhëna",
    "loan.records.6A687Ff5B8F1598F": "Jeni i sigurt që dëshironi të shlyeni më herët?",
    "loan.records.7C20D7008D0Eae86": "Shlyerja ishte e suksesshme",
    "mining.bottomSheet.Ba91637D32Ccba04": "Minierë likuiditeti",
    "mining.bottomSheet.7De3D636A165E008": "Norma e kthimit",
    "mining.bottomSheet.F3003345B189D683": "Afati i minierës",
    "mining.bottomSheet.3E4C0A8C533F5848": "Lloji i monedhës",
    "mining.bottomSheet.Adcba368993Ae65E": "Shuma e abonimit (minimum/maksimum)",
    "mining.bottomSheet.94743B24E4Ed4166": "Pa kufizim",
    "mining.bottomSheet.286944Fedd211257": "Fondet e disponueshme",
    "mining.bottomSheet.7B5766Dc65Abc0C3": "Fitimet e pritura:",
    "mining.bottomSheet.9Bbaf80Fdb6Fd148": "Fillo minierën tani",
    "mining.bottomSheet.Bb1493C567C114Dd": "Këshillë miqësore:",
    "mining.bottomSheet.D2315E87E34A3Bd3": "Tarifa për shlyerje të parakohshme",
    "mining.index.8B2Bba1422Eed6F0": "Krijoni pasuri miliardëshe, të ardhura 100% të pastra",
    "mining.index.42997E300086Ee89": "Fitimi më i lartë",
    "mining.index.510F74F42052Ecce": "Produktet e minierës",
    "mining.index.B853F96626106912": "Shko të minosh",
    "mining.productList.37181C74559Db182": "Porosi",
    "mining.productList.Aac5B810004C46C8": "Afat i caktuar",
    "mining.productList.D2Fb4F78C387D888": "Ju keni minuar me sukses",
    "quantify.bottomSheet.9Ea4A318F690Bc95": "Konfirmo porosinë",
    "quantify.bottomSheet.6915303B698303B1": "Robot",
    "quantify.bottomSheet.68045296Dd0F8Ad6": "Shuma e marrjes me qira",
    "quantify.bottomSheet.Fbd931286Be387Aa": "Cikli",
    "quantify.bottomSheet.9Ad84Db481807844": "Pa afat",
    "quantify.bottomSheet.994D7226Ca083Ea5": "Norma ditore e fitimit",
    "quantify.bottomSheet.0Bf82Ee4Bfe063B7": "Data e fillimit të interesit",
    "quantify.bottomSheet.88008603Ba7Bde64": "Blerja ishte e suksesshme",
    "quantify.bottomSheet.Ff50B3091Bbd09Ab": "Nga sot mund të merrni ndarjen e fitimit!",
    "quantify.bottomSheet.C778A674C4A054F9": "Shiko porosinë",
    "quantify.bottomSheet.685Dad322B7029B0": "Kthehu në tregti",
    "quantify.buyForm.Acf8560A04334E95": "Shuma e blerjes",
    "quantify.buyForm.Cf9Cfbc2C554944F": "Përmbledhje",
    "quantify.buyForm.8788Df2B625E97B5": "Robot",
    "quantify.buyForm.50Ca63B45E881D50": "Koha e shpërndarjes së fitimit",
    "quantify.buyForm.Fcda03Adbc5Fca97": "Çdo ditë",
    "quantify.buyForm.Afb89504Fc399189": "Ju lutemi shkruani sasinë e blerjes",
    "quantify.buyForm.1435Afdfb4Ec0596": "Sasia minimale e blerjes",
    "quantify.buyForm.1B97F1730Bacd839": "Sasia maksimale e blerjes",
    "quantify.index.32F56C9B7D0E250A": "Cikli: Pa afat",
    "quantify.index.E34F028D00904630": "Çmimi",
    "quantify.index.E34F028D00904631": ", Norma ditore e fitimit",
    "quantify.productDetail.6Bbe178Df539A5Ca": "Shuma e administruar",
    "quantify.productDetail.53635B53Bca31Dfa": "Fitimi ditor i pritur",
    "quantify.productDetail.F9E46449A6269E09": "Fitimi kumulativ",
    "quantify.productDetail.98Fc46B1B8C993B2": "Administrimi i porosisë",
    "quantify.productDetail.93624Bb045830966": "Merr me qira tani",
    "quantify.records.0C16A18C32B9Cf4A": "Regjistrat e porosive",
    "quantify.records.B191F5614B0E2312": "Regjistrat e blerjes",
    "quantify.records.6A06033B86A73F7C": "Regjistrat e shlyerjes",
    "quantify.records.45E0F7E71611618E": "Fitimi kumulativ",
    "quantify.records.45E0F7E71611618F": "Fitimi në maturim",
    "quantify.records.Aae1201E38C4Baaa": "Në funksionim",
    "flash.index.C41Fd4F2Fdfa594B": "Shpenzim",
    "flash.index.1Ac59Fa2218E3B00": "E disponueshme:",
    "flash.index.Bf7233A660821549": "Marrë",
    "flash.index.548E775Dd67C7472": "Konfirmo këmbimin",
    "flash.index.066A2449Bd616F03": "Ju lutemi shkruani sasinë e këmbimit",
    "flash.index.Fca26Fcf9C06563F": "Këmbimi i shpejtë ishte i suksesshëm",
    "message.index.40031524233F4564": "Qendra e mesazheve",
    "message.index.8E5586210Fd44D69": "Njoftim për pozicionin e përhershëm",
    "message.index.Bcd3F470E88C197D": "Nuk ka njoftime",
    "message.index.23A557Fbce545879": "Njoftim për likuidimin e detyruar të përhershëm",
    "message.index.B5E19B36B5125550": "Njoftim për tërheqje",
    "message.index.716A981465138334": "Njoftim për depozitë",
    "message.index.884474Ebff2977Ba": "Mesazhe të sistemit",
    "message.index.08Cc7D24752Ec42C": "Shërbimi ndaj klientit online",
    "message.index.1D820A6A19Ab025D": "Shërbim njerëzor online 7 X 24 orë",
    "more.index.29881E0B5Df58Bf7": "Më shumë funksione",
    "more.index.C77Ee35911D10D9D": "Funksione të përdorura shpesh",
    "more.index.3558F69B0260Be61": "Funksionet e tregtimit",
    "more.index.7243Fe610Ed98Cec": "Llogari reale",
    "more.index.7243Fe610Ed98Ced": "Llogari demo",
    "more.index.693C7B35Bdf3E3A3": "Financa",
    "more.index.F855997Fac114554": "Qendra e ndihmës",
    "more.index.Ae9A1252278Da742": "Ndihmë",
    "more.index.Ace012504Bc529E0": "Mesazhe",
    "more.index.05682Dbef5Eeb0A8": "Shërbimi ndaj klientit",
    "more.index.C7Af227A5D5C7Bb9": "Ju keni kaluar në llogarinë reale",
    "more.index.D818A65592694786": "Ju keni kaluar në llogarinë demo",
    "notice.details.B360807Dbe727E6E": "Rreth nesh",
    "notice.details.92F2552F695E70E3": "Rreth nesh",
    "notice.details.7Aaceaf69B67F3D1": "Prezantimi i rregullave",
    "notice.index.6128438Be34Bcb9F": "Njoftime të përhershme",
    "notice.index.71627F5Eb7128261": "Njoftim për tërheqje",
    "notice.index.2Dce570Fda841705": "Njoftim për depozitë",
    "notice.index.228A7C9C6448A9B1": "Njoftim i sistemit",
    "setting.dialog.8B4F5B74660Deabe": "Konfigurimi i ngjyrave",
    "setting.dialog.Bfc7D25486Ebc1A9": "Jeshil rritje, kuq rënie",
    "setting.dialog.796Ea0E1A82C320B": "Kuq rritje, jeshil rënie",
    "setting.index.8Ddc5864E1739466": "Cilësimet e preferencave",
    "setting.index.F5205801D57D6727": "Gjuha",
    "setting.index.2E2C12Dd0Cc1B63B": "Monedha e çmimit",
    "setting.index.322D8496Aec3D918": "Versioni",
    "setting.index.Aa7E6C204C751Cfa": "Dil nga llogaria",
    "share.index.75Bc38Bbf7D2E766": "Fto miqtë",
    "share.index.45575Eb5D42213E6": "Kodi im i ftesës",
    "share.index.29F67F0644A78Bf3": "Kopjo",
    "share.index.19Cc65Bb6Bb98Fe7": "Lidhja ime e ftesës",
    "share.index.5372712F162Fb78B": "Numri i të afërmve direkt",
    "share.index.C88D6B95E3Ab7D6F": "Numri total i të afërmve",
    "share.index.Bb5Fa5471Aeecc62": "Komisioni i të afërmve direkt",
    "share.index.426B6Bac9A5F3D4F": "Komisioni total",
    "share.index.197E4A428F0401C9": "Shiko regjistrat e komisionit",
    "share.records.88A6B2E2B74B13C4": "Regjistrat e komisionit",
    "share.records.B671A35Ffdc93B89": "Komision",
    "transfer.index.B17617A869C03Ca5": "Portofol",
    "transfer.index.E4116Dcc6F6C7270": "Transferimi ishte i suksesshëm",
    "transfer.index.48Fb603C6638C7F6": "Ju lutemi vendosni fjalëkalimin e fondeve",
    "transfer.records.Eb0E39Eb5911D418": "Marrë",
    "transfer.records.977554Be0Aa65052": "Koha e këmbimit të shpejtë:",
    "transfer.records.9Aa33884Aa400B7C": "Koha e transferimit:",
    "form1.forget.76636Db8Fae5B124": "Email-i juaj",
    "form1.forget.35354B9Cca1Bb0E6": "Kodi i verifikimit të email-it",
    "form1.forget.604A0B11E916F387": "Fjalëkalimi",
    "form1.forget.9Cb1C9C51E7503D6": "Konfirmo fjalëkalimin",
    "form1.forget.3A4F7E04B008453C": "Numri juaj i telefonit",
    "form1.forget.Cf11Dce5B4713B5A": "Kodi i verifikimit të telefonit",
    "form1.forget.3012Edba57D4F297": "Ju lutemi shkruani email-in tuaj",
    "form1.forget.F1Ee1D97E869E447": "Ju lutemi shkruani kodin e verifikimit",
    "form1.forget.3A5C4C9Ae68Fa0F6": "Ju lutemi shkruani fjalëkalimin tuaj",
    "form1.forget.C6Cb174Da411D5F7": "Ju lutemi shkruani numrin tuaj të telefonit",
    "form1.forget.947B3B21Ee45E582": "Dërgo",
    "form1.forget.3E0580F1E8630Df6": "Dy fjalëkalimet nuk përputhen",
    "form1.forget.C5A61836B8Cc74C6": "Fjalëkalimi u ndryshua me sukses, duke u ridrejtuar...",
    "form1.forget.B96D072Bc8962565": "Ridërgo",
    "form1.login.2B72C27Ff828Cfc4": "Fjalëkalimi juaj",
    "form1.login.D7C6B872Af9Cb17F": "Më kujto fjalëkalimin tim",
    "form1.login.0Fff44C827A4F3B6": "Hyr",
    "form1.login.1B7F2C1Ede3990Cc": "Ende s’keni llogari? Regjistrohuni tani",
    "form1.login.F657F7Be1Cc33Bd2": "Harrove fjalëkalimin",
    "form1.login.2074A1Eec4B088B0": "Hyrje me portofol",
    "form1.login.1B8938Fbcc3C9B56": "Hyrja ishte e suksesshme, duke u ridrejtuar...",
    "form1.login.07162A7Bb9310555": "Ju lutemi instaloni portofolin ERC20",
    "form1.login.766969966Ae151Dc": "Ju lutemi instaloni portofolin TRC20",
    "form1.login.B88171E1Ad4C50Bf": "Ju refuzuat ndërrimin e rrjetit",
    "form1.register.Aaef0710Cb4Db554": "Futni përsëri fjalëkalimin",
    "form1.register.54Dfea0415C708Ff": "Kodi i ftesës",
    "form1.register.6839940Dac08C794": "Regjistrohu",
    "form1.register.9901A3B5550Aa58E": "Keni tashmë llogari? Hyni",
    "form1.register.2548Ca53785252Ea": "Ju lutemi shkruani kodin tuaj të ftesës",
    "form1.register.Dd71Fd65900Dd03E": "Ju lutemi lexoni dhe pranoni marrëveshjen e regjistrimit",
    "form1.register.7975613909490B77": "Regjistrimi ishte i suksesshëm, duke u ridrejtuar...",
    "form1.walletDialog.105829Acfc0Bd6Aa": "Zgjidh portofolin",
    "userc.certification.2Af9511640153D2E": "Verifikimi bazë",
    "userc.certification.177B191D8E0Fa84D": "Jo i verifikuar",
    "userc.certification.601218D4D572E98A": "I verifikuar",
    "userc.certification.6E37C51Ba9012Fc8": "E pasuksesshme",
    "userc.certification.1B9B563E05C96474": "Verifikimi i avancuar",
    "userc.certification.1418B83803Ab56B4": "Ju lutemi përfundoni fillimisht verifikimin bazë",
    "userc.creditScore.0B149112601Acc4D": "Pikët e kreditit",
    "userc.creditScore.88Ac7F84E106C5F6": "Pikët totale të kreditit",
    "userc.creditScore.3E1D6E0E7F1E6155": "Vlerësimi i sistemit",
    "userc.index.62Eac58D04Bbca0F": "Qendra personale",
    "userc.index.F4Cac53F93Cb2Aff": "Tregtimi demo",
    "userc.index.42F409Fdf3559773": "Qendra e sigurisë",
    "userc.index.1B8E211009807Db8": "Verifikimi i identitetit",
    "userc.index.Bdfcf21Eb8F2Eb70": "Regjistrat e llogarisë",
    "userc.index.6C18D67F6D19586B": "Prezantimi i platformës",
    "userc.index.807A814Ed58A93Bc": "Pastro cache",
    "userc.index.E43Daad59759611C": "Jo i verifikuar",
    "userc.secureCenter.F5C70F0Db2F1Ba76": "Ndrysho fjalëkalimin e hyrjes",
    "userc.secureCenter.1F37Ba427Debf24A": "Lidhja e llogarisë",
    "userc.secureCenter.F9A5Ffa750664004": "Lidhu me verifikuesin e Google",
    "userb.certificationForm.7685Af7D30043Cd6": "Verifikimi bazë",
    "userb.certificationForm.7685Af7D30043Cd7": "Verifikimi i avancuar",
    "userb.certificationForm.70E37C35Abc3F462": "Shteti ku ndodheni",
    "userb.certificationForm.F92C25A68E4D08C5": "Qyteti ku ndodheni",
    "userb.certificationForm.0Ccc6387B38E0318": "Emri juaj",
    "userb.certificationForm.94C67Bba370Fdd46": "Numri i dokumentit",
    "userb.certificationForm.B2D4C7Fffe79258E": "Email",
    "userb.certificationForm.57554268761Fb47A": "Ngarkoni anën e përparme të dokumentit tuaj",
    "userb.certificationForm.D79E90201F5319Bd": "Ngarkoni anën e pasme të dokumentit tuaj",
    "userb.certificationForm.9C6Bad08Af29E20E": "Ngarkoni foton tuaj me dokument në dorë",
    "userb.certificationForm.F96B62Dfa31Cde45": "Konfirmo dërgimin",
    "userb.certificationForm.2125D78Ea8C6D287": "Kërkesat e ngarkimit",
    "userb.certificationForm.0D64864D3076A824": "Shiko shembullin",
    "userb.certificationForm.35287Deb72281E87": "1. Duhet të shihet qartë informacioni i kartës së identitetit.",
    "userb.certificationForm.3007F2E01Efc7B57": "2. Përmbajtja e fotos duhet të jetë e vërtetë dhe e vlefshme, pa ndryshime.",
    "userb.certificationForm.25A90660554319F9": "3. Duhet të shihet qartë numri i dokumentit dhe emri, mbështeten formatet JPG / JPEG / PNG",
    "userb.certificationForm.5A9Aefbc03C778F7": "Ju lutem shkruani",
    "userb.certificationForm.3B7A1D8Ce27C937E": "U dorëzua me sukses, ju lutem prisni verifikimin",
    "userb.certificationForm.744Bd07D8Abd2513": "Ju lutem ngarkoni anën e përparme të dokumentit tuaj",
    "userb.certificationForm.6De1C319130F7Fef": "Ju lutem ngarkoni anën e pasme të dokumentit tuaj",
    "userb.certificationForm.79F8E8B172E30C8A": "Ju lutem ngarkoni foton tuaj me dokument në dorë",
    "userb.certificationForm.46412E16D28A4753": "Ngarkimi i fotos dështoi",
    "userb.changeDialog.676B0Adca1F8Eea4": "Ndrysho fjalëkalimin",
    "userb.modifyInfoDialog.F41De3A1Fa69135A": "Numri i telefonit",
    "userb.modifyInfoDialog.3C3Aac9664A35Ef8": "Ndërrimi i verifikuesit",
    "userb.modifyInfoDialog.62149E566814154C": "Zgjidh verifikuesin",
    "userb.modifyInfoDialog.8E69468E2435Fc89": "Hap aplikacionin e verifikimit dhe kliko +",
    "userb.modifyInfoDialog.7625E5Bdcbfe9963": "Zgjidh 'Skano kodin QR' ose 'Fut çelësin'",
    "userb.modifyInfoDialog.93F094E2B4369472": "Skano kodin QR ose fut çelësin",
    "userb.modifyInfoDialog.43E4F1532529Ee1E": "Fik / Ndiz",
    "userb.modifyInfoDialog.Bae6358Dfd95025A": "Fjalëkalimi i vjetër i fondeve",
    "userb.modifyInfoDialog.E1133Cd4B1C2Abb7": "Fjalëkalimi i ri i fondeve",
    "userb.modifyInfoDialog.C1Ce0403A2523Ee0": "Konfirmo fjalëkalimin e ri të fondeve",
    "userb.modifyInfoDialog.8Dd453Adc2Cd78Fb": "Konfirmo fjalëkalimin e fondeve",
    "userb.modifyInfoDialog.Bb0D9854C79325Bb": "Ju lutem shkruani fjalëkalimin tuaj të vjetër të fondeve",
    "userb.modifyInfoDialog.E66Cb29B00Bc54D1": "Ju lutem shkruani fjalëkalimin tuaj të ri të fondeve",
    "userb.modifyInfoDialog.E8Ae2Ec5Df401255": "Ju lutem shkruani fjalëkalimin tuaj të fondeve",
    "userb.modifyInfoDialog.258A534498Fe984F": "Ju lutem konfirmoni fjalëkalimin tuaj të fondeve",
    "userb.modifyInfoDialog.768Ec43Faa193F08": "Lidhja e llogarisë",
    "userb.modifyInfoDialog.D34746090C25E5Db": "Fjalëkalimi i fondeve",
    "userb.modifyInfoDialog.E4F27D8916E5E536": "Konfirmo",
    "userb.modifyInfoDialog.Bef7160Ce53773E0": "Verifikuesi është çaktivizuar",
    "userb.modifyInfoDialog.Be8Bf47Ba6820De1": "Verifikimi i Google u aktivizua me sukses",
    "userb.modifyInfoDialog.24Dba26593F43C74": "Ndryshimi i fjalëkalimit të fondeve u krye me sukses",
    "userb.modifyInfoDialog.5C369D42Dc7Dbe76": "Vendosja e fjalëkalimit të fondeve u krye me sukses",
    "userb.modifyInfoDialog.667Bf8D0B6C36D4C": "Lidhja ishte e suksesshme",
    "userb.modifyInfoDialog.1C5E05Efee2B0B9F": "Kodi i verifikimit është i pasaktë",
    "userb.veBottomSheet.Eecc4683C725F6F2": "Shembull ngarkimi dokumentesh",
    "userb.veBottomSheet.6F38A0D5858633Ee": "Sfond i errët dhe i pastër",
    "userb.veBottomSheet.Af162Dbdfc4Fcae9": "Dritë e mjaftueshme",
    "userb.veBottomSheet.0F7Baf0Cee3C8141": "Përqendrohuni në kornizën ndihmëse",
    "userb.veBottomSheet.Ac9E471Eead0Cf11": "Foto e qartë",
    "userb.veBottomSheet.50B741382E71F103": "Mundësitë e dështimit",
    "userb.veBottomSheet.Aa56C68E8Fd4Cfb4": "Mbulesa e ID-së nuk është hequr",
    "userb.veBottomSheet.5D2F429C75D4C7F2": "Sfondi ka objekte që pengojnë",
    "userb.veBottomSheet.90F42D3Cb7769Dbc": "Ka reflektime në dokument",
    "userb.veBottomSheet.1Ee78Cee782D81B4": "Dritë shumë e dobët / hija e telefonit e mbulon",
    "userb.veBottomSheet.1A75D2Fc2614592B": "Dokumenti në dorë",
    "home.home.C3525Eb110Db58Aa": "Më shumë",
    "home.home.29761532Fc8Ebecc": "Tregti",
    "home.home.F15Ea99Bfa6E1848": "Verifikim sigurie, blini U me besim",
    "home.home.46E1Ab39Bae7182A": "E shpejtë",
    "home.home.Fde2Eb7F6F3Dd800": "Tregti e shpejtë, përdorim i thjeshtë",
    "home.home.Ea4756Bc1642E0F1": "Emri",
    "home.home.B6B1127Ede1C97B4": "Çmimi më i fundit",
    "home.home.3587Ad870Eb0Ab86": "Ndryshimi 24H",
    "home.home.Cb1A4E14Ec2Cd2B5": "Zbuloni",
    "home.home.0F1B1Ac0E96A40D1": "Blockchain",
    "home.home.8Eaefb1107A0E210": "Forex",
    "home.home.Ad65263D034Ea051": "PMs",
    "home.home.5Fc1474Dbf74Ac1A": "Produkte bujqësore",
    "home.home.135318F4664F7773": "Energjia",
    "kline.kLine.C96Ff250Cf6B8B84": "Çmimi më i lartë 24h",
    "kline.kLine.6E8Be64F19D74565": "Volumi i tregtisë 24h",
    "kline.kLine.08A4Bfbe26A0F262": "Çmimi më i ulët 24h",
    "kline.kLine.8701Deb075066331": "Vlera e tregtisë 24h (USDT)",
    "kline.kLine.Ea3C3052136C84Cd": "1 minutë",
    "kline.kLine.B49Cca240E013124": "5 minuta",
    "kline.kLine.F27A90Be97Ba3D6C": "15 minuta",
    "kline.kLine.Ff3E62395B694384": "30 minuta",
    "kline.kLine.C1993F9C6Db1A674": "1 orë",
    "kline.kLine.Fd2Cbbae405E284C": "1 ditë",
    "kline.kLine.C9Cd71904395042C": "1 muaj",
    "kline.kLine.7D8127Ec18C7B8C7": "Blerësit",
    "kline.kLine.E3D3Ffdb9B3E5636": "Sasia (kontrata)",
    "kline.kLine.6834Fec1838D8029": "Çmimi (USDT)",
    "kline.kLine.16C52Aae474Bc9Cd": "Shitësit",
    "kline.kLine.B9Bea1A9A88D1419": "Hap Long",
    "kline.kLine.D36Cfa96Ee2B343B": "Hap Short",
    "other.navigationBar.F6E62F9642018Cbb": "Faqja kryesore",
    "other.navigationBar.0Ec227161A47B49D": "Tregu",
    "other.navigationBar.29761532Fc8Ebecc": "Tregtia",
    "other.navigationBar.693C7B35Bdf3E3A3": "Financa",
    "other.navigationBar.9734C54620Eb09Af": "Asetet",
    "home.index.25Aa4Fc745150030": "Mbreti i Kriptomonedhave",
    "home.index.2D6Ecf8Faaa8B124": "Më shpejt, më mirë, më i fortë",
    "home.index.1Db26267D1041223": "Tregtoni lehtësisht mbi 1700 kriptomonedha",
    "home.index.F8E18C90C3E35618": "Regjistrohu tani",
    "home.index.29761532Fc8Ebecc": "Tregtia",
    "home.index.D8A95E4506487452": "Kontrata të njohura",
    "home.index.5Bd31Fab681C6E9D": "Shiko më shumë",
    "home.index.010Ae07A09Caf221": "Çiftet tregtare",
    "home.index.F4D875118E6D6Dbb": "Çmimi i fundit i tregtisë",
    "home.index.3Dfdfb3D6599100E": "Ndryshimi 24 orësh",
    "home.index.28Fb39Bd41E54242": "Grafiku i çmimit",
    "home.index.B47A3911Bacd94C6": "Renditja sipas rritjes",
    "home.index.712910D574F43D95": "Fitim i qëndrueshëm",
    "home.index.5507Fd830D7Bf51F": "Strategjitë më të mira, kopjim i lehtë",
    "home.index.7De3D636A165E008": "Norma e kthimit",
    "home.index.B853F96626106912": "Shko të minosh",
    "home.index.213B5C96Be7Cd1F8": "Ditë, norma vjetore",
    "home.index.213B5C96Be7Cd1F9": "Maksimumi për blerje",
    "home.index.Dc710Cffe6313Bb5": "Shiko detajet",
    "home.index.B92Ffc837Ecaa1Dd": "Lajme & Informacione",
    "home.index.6C18D67F6D19586B": "Prezantimi i platformës",
    "home.index.6342E3C33Cb48Cd5": "Kriptomonedha është një mjet shkëmbimi që përdor parimet e kriptografisë për të siguruar transaksionet. Ndryshe nga monedhat fiat si dollari amerikan, kriptomonedhat nuk kanë formë fizike. Kriptovalutat e njohura si Bitcoin (BTC), Ethereum (ETH) dhe Polkadot (DOT) përdorin blockchain si teknologji bazë, duke shërbyer si një regjistër i decentralizuar dixhital. Të gjitha transaksionet e kriptomonedhave regjistrohen në blockchain dhe, pasi të konfirmohen, nuk mund të ndryshohen. Ndryshe nga monedhat tradicionale që mbahen nga bankat në regjistra qendrorë, transaksionet e kriptomonedhave ndodhin në blockchain publik ku kushdo ka akses.",
    "home.index.198Efc4254683Eef": "Për më tepër, sipas mekanizmit të konsensusit, kushdo mund të verifikojë transaksionet e kriptomonedhave dhe t'i shtojë ato në blockchain, duke realizuar decentralizimin. Me kompani globale si Samsung, BlackRock, Morgan Stanley dhe Alphabet që po investojnë, besohet se teknologjia blockchain do të revolucionarizojë sistemin financiar global. Kriptomonedhat ju hapin dyert drejt botës së financave të decentralizuara, duke ju mundësuar të eksploroni mundësitë e pafundme që sjell teknologjia e avancuar.",
    "home.index.E710339D9576292E": "Avantazhet tona",
    "home.index.F9Ce8B2C63885B26": "E sigurt dhe e qëndrueshme",
    "home.index.C4D0A2C9Ff0305Ce": "Ekip teknik i nivelit të lartë, mbrojtje gjithëpërfshirëse sigurie, motor tregtar i zhvilluar vetë me shpejtësi të lartë, që funksionon i qëndrueshëm edhe me miliona transaksione njëkohësisht.",
    "home.index.2E8708Ee3F11Cc1A": "Profesionale dhe e besueshme",
    "home.index.Bb12Cbcf89C56C5C": "Ekip operativ profesionist, përvojë shumëvjeçare në blockchain dhe financa, licenca të rregulluara për tregtim të aseteve dixhitale, garanci 100% të fondeve rezervë.",
    "home.index.Aa4723Bfbf6808F4": "Shërbim me kujdes",
    "home.index.1Bf0204B7D3Ee230": "Për tregun global, mbështetje në disa gjuhë, shërbim 24/7, mbështetje e fortë komunitare dhe shërbim profesional ndaj klientit.",
    "home.index.2E7Dfd53D26F7224": "Performancë e lartë",
    "home.index.1C65453103B5Fcc3": "300,000 transaksione për sekondë, koha e përgjigjes së porosive më pak se 1 milisekondë.",
    "home.index.85Ac49Ece9Dcc80B": "Tregtoni kudo, në çdo kohë!",
    "home.index.2799E18842E4Ebe9": "Hap pozicione menjëherë, mbështetje si në aplikacionin OKEX ashtu edhe në versionin web!",
    "home.index.2Bf52Ce75E29Fc88": "Skanoni për të shkarkuar tani",
    "home.index.88D1422B33571066": "Android",
    "home.index.04Ee893775563F21": "iOS",
    "home.index.04Ee893775563F22": "Shërbime produktesh",
    "home.index.04Ee893775563F23": "Menaxhim financiar",
    "home.index.04Ee893775563F24": "Kthehu",
    "home.index.04Ee893775563F25": "Duke pritur shpalljen e rezultateve",
    "home.index.04Ee893775563F26": "IOS & ANDROID",
    "homepage.text1": "Qëllimi është të bëhemi zgjedhja e parë për klientët",
    "homepage.text1_2": "në tregtimin e kontratave me afat të mallrave",
    "homepage.text2": "Udhëtimi juaj në botën e kriptomonedhave",
    "homepage.text4": "Menaxhim financiar me interes të lartë",
    "homepage.text5": "Menaxhim financiar i qëndrueshëm, norma të larta vjetore",
    "homepage.text6": "Shpërblime për ndarje",
    "homepage.text7": "Tregti e shpejtë, përdorim i thjeshtë",
    "homepage.text8": "Shiko më shumë",
    "homepage.text9": "Shkëmbim i menjëhershëm",
    "homepage.text10": "Verifikim sigurie, blini me besim",
    "homepage.text11": "Ekip teknik i nivelit të lartë, siguri e plotë",
    "homepage.text12": "Mbrojtje, e pavarur",
    "homepage.text13": "Profesionale dhe e besueshme",
    "homepage.text14": "Ekip operativ me përvojë shumëvjeçare në blockchain dhe financa",
    "homepage.text15": "Shërbim me kujdes",
    "homepage.text16": "Për treg global, mbështetje shumëgjuhëshe, operim 24/7",
    "homepage.text17": "Performancë e lartë",
    "homepage.text18": "Përpunon 300,000 transaksione në sekondë, koha e përgjigjes së porosive më pak se 1 milisekondë",
    "passwod.limit":"Gjatësia e fjalëkalimit duhet të jetë më e madhe ose e barabartë me 6 karaktere",
    "finance.header.E5Dd9Bbdab4F52D2": "Investo për ty",
	"finance.header.5Cbf11665B91D51D": "Balanca",
	"finance.index2.B1A4Be8079A937F8": "Intervali i shumës së blerjes",
	"finance.index2.8371E53029Dc7558": "Tarifë për shkelje",
	"finance.index2.Bf9A2C9Bf7Ecaf04": "Përqindja e huasë së lejuar",
	"finance.index2.2Ad78Bbd879C4990": "Apliko tani",
	"finance.index2.A3B7445Ea9D7E111": "Nuk mund të aplikohet",
	"finance.index2.A3B7445Ea9D7E112": "E aplikueshme",
	"finance.index2.87701Fe9Ad8540Dc": "Totali i kuotave të blerjes / kuotat e blera",
	"finance.index2.652Effdf5D1Af6A2": "Norma e pritur e kthimit",
	"finance.index2.D3C3C19De952Fc0C": "Data e aplikimit",
	"finance.index2.6C4C46Cc4Da0C281": "Shuma aktuale",
	"finance.index2.3E9A6703Abd8A3E4": "Fitimi i djeshëm",
	"finance.index2.596704E9869C8134": "Fitimi total",
	"finance.index2.0A845B549624B74B": "Norma vjetore e kthimit",
	"finance.index2.9A7758Cad0402366": "Aktualisht në mbajtje",
	"finance.index2.9A7758Cad0402367": "Regjistri i fitimit",
	"finance.index2.8B8Ceb7610C747Eb": "Historia",
	"finance.index2.8B8Ceb7610C747Ec": "Regjistri i investimeve",
	"finance.index2.0B049108D57B9Dd5": "Tërheqje e parakohshme",
	"finance.index2.37Ffde1Ee1D3C8D4": "Tërhequr më herët",
	"finance.index2.12F6B830Aee90Efb": "Ka skaduar",
	"finance.index2.40E1944D8Cafbdad": "Shuma e mbajtur",
	"finance.index2.9815C4F248B624F5": "Data e blerjes",
	"finance.index2.46F7Be1133B3E2C6": "Data e përfundimit",
	"finance.index2.Fc8643Aa7Babcce8": "Fitimi",
	"finance.index2.1F2B02E97721B997": "A do të tërhiqet më herët",
	"finance.index2.14E543A74595Efe8": "Në aplikim",
	"finance.index2.14E543A74595Efe9": "Në proces",
	"finance.index2.14E543A74595Efe0": "E përfunduar",
	"finance.index2.8E29Fbba37286B63": "Emri i mentorit",
	"finance.index2.D736C17Df71Bcdb2": "Sasia e aplikimit",
	"finance.index2.F38884Ed4410D9F6": "Sasia e suksesshme",
	"finance.index2.E3347Eb6F76Eda1C": "Fitim i realizuar",
	"finance.index2.0Fc0070Cb4E9F5A8": "Koha e investimit",
	"finance.index2.8Efd11Be6D9F43Df": "Koha e fillimit të fitimit",
	"finance.index2.16658A855F07D171": "Shuma",
	"finance.index2.184333C81Babf2F1": "Lloji",
	"finance.index2.15Cba911299D4Afd": "Apliko tani",
	"finance.index2.Da1Cdb155Ae381Cd": "Shuma e tërheqjes",
	"finance.index2.15Efec8F145F2608": "Shuma aktuale (USDT): ",
	"finance.index2.159253C05C270D46": "Shuma e mbajtur (USDT): ",
	"finance.index2.Caab3A4Ba941E0E3": "Tarifa për tërheqje të parakohshme (USDT): ",
	"finance.index2.Fb5Fc50Cf3716723": "Mund të blihet",
	"finance.index2.5Dcb4Ee5C7F1F4E1": "Shkruaj shumën",
	"finance.index2.5886C88906Cc4491": "Ekip mentorësh yjorë, kujdesemi për çdo qindarkë tuajën",
	"finance.index2.5886C88906Cc4492": "Kapital i siguruar, interes i garantuar, fleksibilitet në depozitim dhe tërheqje, fitim edhe në luhatje të tregut",
	"finance.index2.F5Af24Dbad5837Ea": "Rikthim i suksesshëm",
    "finance.index2.Be15Df7F1D76F9B2": "Shuma e investuar",
	"finance.index2.Fc57951B528F3Dd3": "Mund të huazohet",
	"finance.index2.3F91F76109Fdbdeb": "Tashmë e huazuar",
	"finance.index2.F68600F93Fe31213": "Huazo",
	"finance.index2.494E47D4025Da8E6": "Shlyej",
	"finance.index2.27F6657Ebf2025E3": "Shuma e huazuar",
	"finance.index2.27F6657Ebf2025E4": "Shuma e shlyer",
	"finance.index2.631Fc4Ce8Aeee66F": "Konfirmo huanë",
	"finance.index2.631Fc4Ce8Aeee66G": "Konfirmo shlyerjen",
    "time.text1":"Data e fillimit",
    "finance.index2.631Fc4Ce8Aeee66H": "Në pritje të konfirmimit",
    "passwod.limit":"Gjatësia e fjalëkalimit duhet të jetë më e madhe ose e barabartë me 6 karaktere",
    "turntable.title": "Shorteu",
    "turntable.title2": "Shorte me fat",
    "turntable.sub": "Fati të pret",
    "turntable.count": "Numri i shorteve: ",
    "turntable.rule": "Rregullat e shortit",
    "turntable.history": "Regjistri i fitoreve",
    "turntable.tip1": "Urime, ju fituat",
    "turntable.tip2": "Fatkeqësisht nuk fituat",
}
